const productsData = [
  {
    id: 1,
    title: 'Tort botez 1',
    description: 'Descriere tort botez 1',
    image: '/images/baptism-cakes/00001.webp',
    type: 'baptismCakes',
  },
  {
    id: 2,
    title: 'Tort botez 2',
    description: 'Descriere tort botez 2',
    image: '/images/baptism-cakes/00002.webp',
    type: 'baptismCakes',
  },
  {
    id: 3,
    title: 'Tort botez 3',
    description: 'Descriere tort botez 3',
    image: '/images/baptism-cakes/00003.webp',
    type: 'baptismCakes',
  },
  {
    id: 4,
    title: 'Tort botez 4',
    description: 'Descriere tort botez 4',
    image: '/images/baptism-cakes/00004.webp',
    type: 'baptismCakes',
  },
  {
    id: 5,
    title: 'Tort botez 5',
    description: 'Descriere tort botez 5',
    image: '/images/baptism-cakes/00005.webp',
    type: 'baptismCakes',
  },
  {
    id: 6,
    title: 'Tort botez 6',
    description: 'Descriere tort botez 6',
    image: '/images/baptism-cakes/00006.webp',
    type: 'baptismCakes',
  },
  {
    id: 7,
    title: 'Tort botez 7',
    description: 'Descriere tort botez 7',
    image: '/images/baptism-cakes/00007.webp',
    type: 'baptismCakes',
  },
  {
    id: 8,
    title: 'Tort botez 8',
    description: 'Descriere tort botez 8',
    image: '/images/baptism-cakes/00008.webp',
    type: 'baptismCakes',
  },
  {
    id: 9,
    title: 'Tort botez 9',
    description: 'Descriere tort botez 9',
    image: '/images/baptism-cakes/00009.webp',
    type: 'baptismCakes',
  },
  {
    id: 10,
    title: 'Tort botez 10',
    description: 'Descriere tort botez 10',
    image: '/images/baptism-cakes/00010.webp',
    type: 'baptismCakes',
  },
  {
    id: 11,
    title: 'Tort botez 11',
    description: 'Descriere tort botez 11',
    image: '/images/baptism-cakes/00011.webp',
    type: 'baptismCakes',
  },
  {
    id: 12,
    title: 'Tort botez 12',
    description: 'Descriere tort botez 12',
    image: '/images/baptism-cakes/00012.webp',
    type: 'baptismCakes',
  },
  {
    id: 13,
    title: 'Tort botez 13',
    description: 'Descriere tort botez 13',
    image: '/images/baptism-cakes/00013.webp',
    type: 'baptismCakes',
  },
  {
    id: 14,
    title: 'Tort botez 14',
    description: 'Descriere tort botez 14',
    image: '/images/baptism-cakes/00014.webp',
    type: 'baptismCakes',
  },
  {
    id: 15,
    title: 'Tort botez 15',
    description: 'Descriere tort botez 15',
    image: '/images/baptism-cakes/00015.webp',
    type: 'baptismCakes',
  },
  {
    id: 16,
    title: 'Tort botez 16',
    description: 'Descriere tort botez 16',
    image: '/images/baptism-cakes/00016.webp',
    type: 'baptismCakes',
  },
  {
    id: 17,
    title: 'Tort botez 17',
    description: 'Descriere tort botez 17',
    image: '/images/baptism-cakes/00017.webp',
    type: 'baptismCakes',
  },
  {
    id: 18,
    title: 'Tort botez 18',
    description: 'Descriere tort botez 18',
    image: '/images/baptism-cakes/00018.webp',
    type: 'baptismCakes',
  },
  {
    id: 19,
    title: 'Tort botez 19',
    description: 'Descriere tort botez 19',
    image: '/images/baptism-cakes/00019.webp',
    type: 'baptismCakes',
  },
  {
    id: 20,
    title: 'Tort botez 20',
    description: 'Descriere tort botez 20',
    image: '/images/baptism-cakes/00020.webp',
    type: 'baptismCakes',
  },
  {
    id: 21,
    title: 'Tort botez 21',
    description: 'Descriere tort botez 21',
    image: '/images/baptism-cakes/00021.webp',
    type: 'baptismCakes',
  },
  {
    id: 22,
    title: 'Tort botez 22',
    description: 'Descriere tort botez 22',
    image: '/images/baptism-cakes/00022.webp',
    type: 'baptismCakes',
  },
  {
    id: 23,
    title: 'Tort botez 23',
    description: 'Descriere tort botez 23',
    image: '/images/baptism-cakes/00023.webp',
    type: 'baptismCakes',
  },
  {
    id: 24,
    title: 'Tort botez 24',
    description: 'Descriere tort botez 24',
    image: '/images/baptism-cakes/00024.webp',
    type: 'baptismCakes',
  },
  {
    id: 25,
    title: 'Tort botez 25',
    description: 'Descriere tort botez 25',
    image: '/images/baptism-cakes/00025.webp',
    type: 'baptismCakes',
  },
  {
    id: 26,
    title: 'Tort botez 26',
    description: 'Descriere tort botez 26',
    image: '/images/baptism-cakes/00026.webp',
    type: 'baptismCakes',
  },
  {
    id: 27,
    title: 'Tort botez 27',
    description: 'Descriere tort botez 27',
    image: '/images/baptism-cakes/00027.webp',
    type: 'baptismCakes',
  },
  {
    id: 28,
    title: 'Tort botez 28',
    description: 'Descriere tort botez 28',
    image: '/images/baptism-cakes/00028.webp',
    type: 'baptismCakes',
  },
  {
    id: 29,
    title: 'Tort botez 29',
    description: 'Descriere tort botez 29',
    image: '/images/baptism-cakes/00029.webp',
    type: 'baptismCakes',
  },
  {
    id: 30,
    title: 'Tort botez 30',
    description: 'Descriere tort botez 30',
    image: '/images/baptism-cakes/00030.webp',
    type: 'baptismCakes',
  },
  {
    id: 31,
    title: 'Tort botez 31',
    description: 'Descriere tort botez 31',
    image: '/images/baptism-cakes/00031.webp',
    type: 'baptismCakes',
  },
  {
    id: 32,
    title: 'Tort botez 32',
    description: 'Descriere tort botez 32',
    image: '/images/baptism-cakes/00032.webp',
    type: 'baptismCakes',
  },
  {
    id: 33,
    title: 'Tort botez 33',
    description: 'Descriere tort botez 33',
    image: '/images/baptism-cakes/00033.webp',
    type: 'baptismCakes',
  },
  {
    id: 34,
    title: 'Tort botez 34',
    description: 'Descriere tort botez 34',
    image: '/images/baptism-cakes/00034.webp',
    type: 'baptismCakes',
  },
  {
    id: 35,
    title: 'Tort botez 35',
    description: 'Descriere tort botez 35',
    image: '/images/baptism-cakes/00035.webp',
    type: 'baptismCakes',
  },
  {
    id: 36,
    title: 'Tort botez 36',
    description: 'Descriere tort botez 36',
    image: '/images/baptism-cakes/00036.webp',
    type: 'baptismCakes',
  },
  {
    id: 37,
    title: 'Tort botez 37',
    description: 'Descriere tort botez 37',
    image: '/images/baptism-cakes/00037.webp',
    type: 'baptismCakes',
  },
  {
    id: 38,
    title: 'Tort botez 38',
    description: 'Descriere tort botez 38',
    image: '/images/baptism-cakes/00038.webp',
    type: 'baptismCakes',
  },
  {
    id: 39,
    title: 'Tort botez 39',
    description: 'Descriere tort botez 39',
    image: '/images/baptism-cakes/00039.webp',
    type: 'baptismCakes',
  },
  {
    id: 40,
    title: 'Tort botez 40',
    description: 'Descriere tort botez 40',
    image: '/images/baptism-cakes/00040.webp',
    type: 'baptismCakes',
  },
  {
    id: 41,
    title: 'Tort botez 41',
    description: 'Descriere tort botez 41',
    image: '/images/baptism-cakes/00041.webp',
    type: 'baptismCakes',
  },
  {
    id: 42,
    title: 'Tort botez 42',
    description: 'Descriere tort botez 42',
    image: '/images/baptism-cakes/00042.webp',
    type: 'baptismCakes',
  },
  {
    id: 43,
    title: 'Tort botez 43',
    description: 'Descriere tort botez 43',
    image: '/images/baptism-cakes/00043.webp',
    type: 'baptismCakes',
  },
  {
    id: 44,
    title: 'Tort botez 44',
    description: 'Descriere tort botez 44',
    image: '/images/baptism-cakes/00044.webp',
    type: 'baptismCakes',
  },
  {
    id: 45,
    title: 'Tort botez 45',
    description: 'Descriere tort botez 45',
    image: '/images/baptism-cakes/00045.webp',
    type: 'baptismCakes',
  },
  {
    id: 46,
    title: 'Tort botez 46',
    description: 'Descriere tort botez 46',
    image: '/images/baptism-cakes/00046.webp',
    type: 'baptismCakes',
  },
  {
    id: 47,
    title: 'Tort botez 47',
    description: 'Descriere tort botez 47',
    image: '/images/baptism-cakes/00047.webp',
    type: 'baptismCakes',
  },
  {
    id: 48,
    title: 'Tort botez 48',
    description: 'Descriere tort botez 48',
    image: '/images/baptism-cakes/00048.webp',
    type: 'baptismCakes',
  },
  {
    id: 49,
    title: 'Tort botez 49',
    description: 'Descriere tort botez 49',
    image: '/images/baptism-cakes/00049.webp',
    type: 'baptismCakes',
  },
  {
    id: 50,
    title: 'Tort botez 50',
    description: 'Descriere tort botez 50',
    image: '/images/baptism-cakes/00050.webp',
    type: 'baptismCakes',
  },
  {
    id: 51,
    title: 'Tort botez 51',
    description: 'Descriere tort botez 51',
    image: '/images/baptism-cakes/00051.webp',
    type: 'baptismCakes',
  },
  {
    id: 52,
    title: 'Tort botez 52',
    description: 'Descriere tort botez 52',
    image: '/images/baptism-cakes/00052.webp',
    type: 'baptismCakes',
  },
  {
    id: 53,
    title: 'Tort botez 53',
    description: 'Descriere tort botez 53',
    image: '/images/baptism-cakes/00053.webp',
    type: 'baptismCakes',
  },
  {
    id: 54,
    title: 'Tort botez 54',
    description: 'Descriere tort botez 54',
    image: '/images/baptism-cakes/00054.webp',
    type: 'baptismCakes',
  },
  {
    id: 55,
    title: 'Tort botez 55',
    description: 'Descriere tort botez 55',
    image: '/images/baptism-cakes/00055.webp',
    type: 'baptismCakes',
  },
  {
    id: 56,
    title: 'Tort botez 56',
    description: 'Descriere tort botez 56',
    image: '/images/baptism-cakes/00056.webp',
    type: 'baptismCakes',
  },
  {
    id: 57,
    title: 'Tort botez 57',
    description: 'Descriere tort botez 57',
    image: '/images/baptism-cakes/00057.webp',
    type: 'baptismCakes',
  },
  {
    id: 58,
    title: 'Tort botez 58',
    description: 'Descriere tort botez 58',
    image: '/images/baptism-cakes/00058.webp',
    type: 'baptismCakes',
  },
  {
    id: 59,
    title: 'Tort botez 59',
    description: 'Descriere tort botez 59',
    image: '/images/baptism-cakes/00059.webp',
    type: 'baptismCakes',
  },
  {
    id: 60,
    title: 'Tort botez 60',
    description: 'Descriere tort botez 60',
    image: '/images/baptism-cakes/00060.webp',
    type: 'baptismCakes',
  },
  {
    id: 61,
    title: 'Tort botez 61',
    description: 'Descriere tort botez 61',
    image: '/images/baptism-cakes/00061.webp',
    type: 'baptismCakes',
  },
  {
    id: 62,
    title: 'Tort botez 62',
    description: 'Descriere tort botez 62',
    image: '/images/baptism-cakes/00062.webp',
    type: 'baptismCakes',
  },
  {
    id: 63,
    title: 'Tort botez 63',
    description: 'Descriere tort botez 63',
    image: '/images/baptism-cakes/00063.webp',
    type: 'baptismCakes',
  },
  {
    id: 64,
    title: 'Tort botez 64',
    description: 'Descriere tort botez 64',
    image: '/images/baptism-cakes/00064.webp',
    type: 'baptismCakes',
  },
  {
    id: 65,
    title: 'Tort botez 65',
    description: 'Descriere tort botez 65',
    image: '/images/baptism-cakes/00065.webp',
    type: 'baptismCakes',
  },
  {
    id: 66,
    title: 'Tort botez 66',
    description: 'Descriere tort botez 66',
    image: '/images/baptism-cakes/00066.webp',
    type: 'baptismCakes',
  },
  {
    id: 67,
    title: 'Tort botez 67',
    description: 'Descriere tort botez 67',
    image: '/images/baptism-cakes/00067.webp',
    type: 'baptismCakes',
  },
  {
    id: 68,
    title: 'Tort botez 68',
    description: 'Descriere tort botez 68',
    image: '/images/baptism-cakes/00068.webp',
    type: 'baptismCakes',
  },
  {
    id: 69,
    title: 'Tort botez 69',
    description: 'Descriere tort botez 69',
    image: '/images/baptism-cakes/00069.webp',
    type: 'baptismCakes',
  },
  {
    id: 70,
    title: 'Tort botez 70',
    description: 'Descriere tort botez 70',
    image: '/images/baptism-cakes/00070.webp',
    type: 'baptismCakes',
  },
  {
    id: 71,
    title: 'Tort botez 71',
    description: 'Descriere tort botez 71',
    image: '/images/baptism-cakes/00071.webp',
    type: 'baptismCakes',
  },
  {
    id: 72,
    title: 'Tort botez 72',
    description: 'Descriere tort botez 72',
    image: '/images/baptism-cakes/00072.webp',
    type: 'baptismCakes',
  },
  {
    id: 73,
    title: 'Tort botez 73',
    description: 'Descriere tort botez 73',
    image: '/images/baptism-cakes/00073.webp',
    type: 'baptismCakes',
  },
  {
    id: 74,
    title: 'Tort botez 74',
    description: 'Descriere tort botez 74',
    image: '/images/baptism-cakes/00074.webp',
    type: 'baptismCakes',
  },
  {
    id: 75,
    title: 'Tort botez 75',
    description: 'Descriere tort botez 75',
    image: '/images/baptism-cakes/00075.webp',
    type: 'baptismCakes',
  },
  {
    id: 76,
    title: 'Tort botez 76',
    description: 'Descriere tort botez 76',
    image: '/images/baptism-cakes/00076.webp',
    type: 'baptismCakes',
  },
  {
    id: 77,
    title: 'Tort botez 77',
    description: 'Descriere tort botez 77',
    image: '/images/baptism-cakes/00077.webp',
    type: 'baptismCakes',
  },
  {
    id: 78,
    title: 'Tort botez 78',
    description: 'Descriere tort botez 78',
    image: '/images/baptism-cakes/00078.webp',
    type: 'baptismCakes',
  },
  {
    id: 79,
    title: 'Tort botez 79',
    description: 'Descriere tort botez 79',
    image: '/images/baptism-cakes/00079.webp',
    type: 'baptismCakes',
  },
  {
    id: 80,
    title: 'Tort botez 80',
    description: 'Descriere tort botez 80',
    image: '/images/baptism-cakes/00080.webp',
    type: 'baptismCakes',
  },
  {
    id: 81,
    title: 'Tort botez 81',
    description: 'Descriere tort botez 81',
    image: '/images/baptism-cakes/00081.webp',
    type: 'baptismCakes',
  },
  {
    id: 82,
    title: 'Tort botez 82',
    description: 'Descriere tort botez 82',
    image: '/images/baptism-cakes/00082.webp',
    type: 'baptismCakes',
  },
  {
    id: 83,
    title: 'Tort botez 83',
    description: 'Descriere tort botez 83',
    image: '/images/baptism-cakes/00083.webp',
    type: 'baptismCakes',
  },
  {
    id: 84,
    title: 'Tort botez 84',
    description: 'Descriere tort botez 84',
    image: '/images/baptism-cakes/00084.webp',
    type: 'baptismCakes',
  },
  {
    id: 85,
    title: 'Tort botez 85',
    description: 'Descriere tort botez 85',
    image: '/images/baptism-cakes/00085.webp',
    type: 'baptismCakes',
  },
  {
    id: 86,
    title: 'Tort botez 86',
    description: 'Descriere tort botez 86',
    image: '/images/baptism-cakes/00086.webp',
    type: 'baptismCakes',
  },
  {
    id: 87,
    title: 'Tort botez 87',
    description: 'Descriere tort botez 87',
    image: '/images/baptism-cakes/00087.webp',
    type: 'baptismCakes',
  },
  {
    id: 88,
    title: 'Tort botez 88',
    description: 'Descriere tort botez 88',
    image: '/images/baptism-cakes/00088.webp',
    type: 'baptismCakes',
  },
  {
    id: 89,
    title: 'Tort botez 89',
    description: 'Descriere tort botez 89',
    image: '/images/baptism-cakes/00089.webp',
    type: 'baptismCakes',
  },
  {
    id: 90,
    title: 'Tort botez 90',
    description: 'Descriere tort botez 90',
    image: '/images/baptism-cakes/00090.webp',
    type: 'baptismCakes',
  },
  {
    id: 91,
    title: 'Tort botez 91',
    description: 'Descriere tort botez 91',
    image: '/images/baptism-cakes/00091.webp',
    type: 'baptismCakes',
  },
  {
    id: 92,
    title: 'Tort botez 92',
    description: 'Descriere tort botez 92',
    image: '/images/baptism-cakes/00092.webp',
    type: 'baptismCakes',
  },
  {
    id: 93,
    title: 'Tort botez 93',
    description: 'Descriere tort botez 93',
    image: '/images/baptism-cakes/00093.webp',
    type: 'baptismCakes',
  },
  {
    id: 94,
    title: 'Tort botez 94',
    description: 'Descriere tort botez 94',
    image: '/images/baptism-cakes/00094.webp',
    type: 'baptismCakes',
  },
  {
    id: 95,
    title: 'Tort botez 95',
    description: 'Descriere tort botez 95',
    image: '/images/baptism-cakes/00095.webp',
    type: 'baptismCakes',
  },
  {
    id: 96,
    title: 'Tort botez 96',
    description: 'Descriere tort botez 96',
    image: '/images/baptism-cakes/00096.webp',
    type: 'baptismCakes',
  },
  {
    id: 97,
    title: 'Tort botez 97',
    description: 'Descriere tort botez 97',
    image: '/images/baptism-cakes/00097.webp',
    type: 'baptismCakes',
  },
  {
    id: 98,
    title: 'Tort botez 98',
    description: 'Descriere tort botez 98',
    image: '/images/baptism-cakes/00098.webp',
    type: 'baptismCakes',
  },
  {
    id: 99,
    title: 'Tort botez 99',
    description: 'Descriere tort botez 99',
    image: '/images/baptism-cakes/00099.webp',
    type: 'baptismCakes',
  },
  {
    id: 100,
    title: 'Tort botez 100',
    description: 'Descriere tort botez 100',
    image: '/images/baptism-cakes/00100.webp',
    type: 'baptismCakes',
  },
  {
    id: 101,
    title: 'Tort botez 101',
    description: 'Descriere tort botez 101',
    image: '/images/baptism-cakes/00101.webp',
    type: 'baptismCakes',
  },
  {
    id: 102,
    title: 'Tort botez 102',
    description: 'Descriere tort botez 102',
    image: '/images/baptism-cakes/00102.webp',
    type: 'baptismCakes',
  },
  {
    id: 103,
    title: 'Tort botez 103',
    description: 'Descriere tort botez 103',
    image: '/images/baptism-cakes/00103.webp',
    type: 'baptismCakes',
  },
  {
    id: 104,
    title: 'Tort botez 104',
    description: 'Descriere tort botez 104',
    image: '/images/baptism-cakes/00104.webp',
    type: 'baptismCakes',
  },
  {
    id: 105,
    title: 'Tort botez 105',
    description: 'Descriere tort botez 105',
    image: '/images/baptism-cakes/00105.webp',
    type: 'baptismCakes',
  },
  {
    id: 106,
    title: 'Tort botez 106',
    description: 'Descriere tort botez 106',
    image: '/images/baptism-cakes/00106.webp',
    type: 'baptismCakes',
  },
  {
    id: 107,
    title: 'Tort botez 107',
    description: 'Descriere tort botez 107',
    image: '/images/baptism-cakes/00107.webp',
    type: 'baptismCakes',
  },
  {
    id: 108,
    title: 'Tort botez 108',
    description: 'Descriere tort botez 108',
    image: '/images/baptism-cakes/00108.webp',
    type: 'baptismCakes',
  },
  {
    id: 109,
    title: 'Tort botez 109',
    description: 'Descriere tort botez 109',
    image: '/images/baptism-cakes/00109.webp',
    type: 'baptismCakes',
  },
  {
    id: 110,
    title: 'Tort botez 110',
    description: 'Descriere tort botez 110',
    image: '/images/baptism-cakes/00110.webp',
    type: 'baptismCakes',
  },
  {
    id: 111,
    title: 'Tort botez 111',
    description: 'Descriere tort botez 111',
    image: '/images/baptism-cakes/00111.webp',
    type: 'baptismCakes',
  },
  {
    id: 112,
    title: 'Tort botez 112',
    description: 'Descriere tort botez 112',
    image: '/images/baptism-cakes/00112.webp',
    type: 'baptismCakes',
  },
  {
    id: 113,
    title: 'Tort botez 113',
    description: 'Descriere tort botez 113',
    image: '/images/baptism-cakes/00113.webp',
    type: 'baptismCakes',
  },
  {
    id: 114,
    title: 'Tort botez 114',
    description: 'Descriere tort botez 114',
    image: '/images/baptism-cakes/00114.webp',
    type: 'baptismCakes',
  },
  {
    id: 115,
    title: 'Tort botez 115',
    description: 'Descriere tort botez 115',
    image: '/images/baptism-cakes/00115.webp',
    type: 'baptismCakes',
  },
  {
    id: 116,
    title: 'Tort botez 116',
    description: 'Descriere tort botez 116',
    image: '/images/baptism-cakes/00116.webp',
    type: 'baptismCakes',
  },
  {
    id: 117,
    title: 'Tort botez 117',
    description: 'Descriere tort botez 117',
    image: '/images/baptism-cakes/00117.webp',
    type: 'baptismCakes',
  },
  {
    id: 118,
    title: 'Tort botez 118',
    description: 'Descriere tort botez 118',
    image: '/images/baptism-cakes/00118.webp',
    type: 'baptismCakes',
  },
  {
    id: 119,
    title: 'Tort botez 119',
    description: 'Descriere tort botez 119',
    image: '/images/baptism-cakes/00119.webp',
    type: 'baptismCakes',
  },
  {
    id: 120,
    title: 'Tort botez 120',
    description: 'Descriere tort botez 120',
    image: '/images/baptism-cakes/00120.webp',
    type: 'baptismCakes',
  },
  {
    id: 121,
    title: 'Tort botez 121',
    description: 'Descriere tort botez 121',
    image: '/images/baptism-cakes/00121.webp',
    type: 'baptismCakes',
  },
  {
    id: 122,
    title: 'Tort botez 122',
    description: 'Descriere tort botez 122',
    image: '/images/baptism-cakes/00122.webp',
    type: 'baptismCakes',
  },
  {
    id: 123,
    title: 'Tort botez 123',
    description: 'Descriere tort botez 123',
    image: '/images/baptism-cakes/00123.webp',
    type: 'baptismCakes',
  },
  {
    id: 124,
    title: 'Tort botez 124',
    description: 'Descriere tort botez 124',
    image: '/images/baptism-cakes/00124.webp',
    type: 'baptismCakes',
  },
  {
    id: 125,
    title: 'Tort botez 125',
    description: 'Descriere tort botez 125',
    image: '/images/baptism-cakes/00125.webp',
    type: 'baptismCakes',
  },
  {
    id: 126,
    title: 'Tort botez 126',
    description: 'Descriere tort botez 126',
    image: '/images/baptism-cakes/00126.webp',
    type: 'baptismCakes',
  },
  {
    id: 127,
    title: 'Tort botez 127',
    description: 'Descriere tort botez 127',
    image: '/images/baptism-cakes/00127.webp',
    type: 'baptismCakes',
  },
  {
    id: 128,
    title: 'Tort botez 128',
    description: 'Descriere tort botez 128',
    image: '/images/baptism-cakes/00128.webp',
    type: 'baptismCakes',
  },
  {
    id: 129,
    title: 'Tort botez 129',
    description: 'Descriere tort botez 129',
    image: '/images/baptism-cakes/00129.webp',
    type: 'baptismCakes',
  },
  {
    id: 130,
    title: 'Tort botez 130',
    description: 'Descriere tort botez 130',
    image: '/images/baptism-cakes/00130.webp',
    type: 'baptismCakes',
  },
  {
    id: 131,
    title: 'Tort botez 131',
    description: 'Descriere tort botez 131',
    image: '/images/baptism-cakes/00131.webp',
    type: 'baptismCakes',
  },
  {
    id: 132,
    title: 'Tort botez 132',
    description: 'Descriere tort botez 132',
    image: '/images/baptism-cakes/00132.webp',
    type: 'baptismCakes',
  },
  {
    id: 133,
    title: 'Tort botez 133',
    description: 'Descriere tort botez 133',
    image: '/images/baptism-cakes/00133.webp',
    type: 'baptismCakes',
  },
  {
    id: 134,
    title: 'Tort botez 134',
    description: 'Descriere tort botez 134',
    image: '/images/baptism-cakes/00134.webp',
    type: 'baptismCakes',
  },
  {
    id: 135,
    title: 'Tort botez 135',
    description: 'Descriere tort botez 135',
    image: '/images/baptism-cakes/00135.webp',
    type: 'baptismCakes',
  },
  {
    id: 136,
    title: 'Tort botez 136',
    description: 'Descriere tort botez 136',
    image: '/images/baptism-cakes/00136.webp',
    type: 'baptismCakes',
  },
  {
    id: 137,
    title: 'Tort botez 137',
    description: 'Descriere tort botez 137',
    image: '/images/baptism-cakes/00137.webp',
    type: 'baptismCakes',
  },
  {
    id: 138,
    title: 'Tort botez 138',
    description: 'Descriere tort botez 138',
    image: '/images/baptism-cakes/00138.webp',
    type: 'baptismCakes',
  },
  {
    id: 139,
    title: 'Tort botez 139',
    description: 'Descriere tort botez 139',
    image: '/images/baptism-cakes/00139.webp',
    type: 'baptismCakes',
  },
  {
    id: 140,
    title: 'Tort botez 140',
    description: 'Descriere tort botez 140',
    image: '/images/baptism-cakes/00140.webp',
    type: 'baptismCakes',
  },
  {
    id: 141,
    title: 'Tort botez 141',
    description: 'Descriere tort botez 141',
    image: '/images/baptism-cakes/00141.webp',
    type: 'baptismCakes',
  },
  {
    id: 142,
    title: 'Tort botez 142',
    description: 'Descriere tort botez 142',
    image: '/images/baptism-cakes/00142.webp',
    type: 'baptismCakes',
  },
  {
    id: 143,
    title: 'Tort botez 143',
    description: 'Descriere tort botez 143',
    image: '/images/baptism-cakes/00143.webp',
    type: 'baptismCakes',
  },
  {
    id: 144,
    title: 'Tort botez 144',
    description: 'Descriere tort botez 144',
    image: '/images/baptism-cakes/00144.webp',
    type: 'baptismCakes',
  },
  {
    id: 145,
    title: 'Tort botez 145',
    description: 'Descriere tort botez 145',
    image: '/images/baptism-cakes/00145.webp',
    type: 'baptismCakes',
  },
  {
    id: 146,
    title: 'Tort botez 146',
    description: 'Descriere tort botez 146',
    image: '/images/baptism-cakes/00146.webp',
    type: 'baptismCakes',
  },
  {
    id: 147,
    title: 'Tort botez 147',
    description: 'Descriere tort botez 147',
    image: '/images/baptism-cakes/00147.webp',
    type: 'baptismCakes',
  },
  {
    id: 148,
    title: 'Tort botez 148',
    description: 'Descriere tort botez 148',
    image: '/images/baptism-cakes/00148.webp',
    type: 'baptismCakes',
  },
  {
    id: 149,
    title: 'Tort botez 149',
    description: 'Descriere tort botez 149',
    image: '/images/baptism-cakes/00149.webp',
    type: 'baptismCakes',
  },
  {
    id: 150,
    title: 'Tort botez 150',
    description: 'Descriere tort botez 150',
    image: '/images/baptism-cakes/00150.webp',
    type: 'baptismCakes',
  },
  {
    id: 151,
    title: 'Tort botez 151',
    description: 'Descriere tort botez 151',
    image: '/images/baptism-cakes/00151.webp',
    type: 'baptismCakes',
  },
  {
    id: 152,
    title: 'Tort botez 152',
    description: 'Descriere tort botez 152',
    image: '/images/baptism-cakes/00152.webp',
    type: 'baptismCakes',
  },
  {
    id: 153,
    title: 'Tort botez 153',
    description: 'Descriere tort botez 153',
    image: '/images/baptism-cakes/00153.webp',
    type: 'baptismCakes',
  },
  {
    id: 154,
    title: 'Tort botez 154',
    description: 'Descriere tort botez 154',
    image: '/images/baptism-cakes/00154.webp',
    type: 'baptismCakes',
  },
  {
    id: 155,
    title: 'Tort botez 155',
    description: 'Descriere tort botez 155',
    image: '/images/baptism-cakes/00155.webp',
    type: 'baptismCakes',
  },
  {
    id: 156,
    title: 'Tort botez 156',
    description: 'Descriere tort botez 156',
    image: '/images/baptism-cakes/00156.webp',
    type: 'baptismCakes',
  },
  {
    id: 157,
    title: 'Tort botez 157',
    description: 'Descriere tort botez 157',
    image: '/images/baptism-cakes/00157.webp',
    type: 'baptismCakes',
  },
  {
    id: 158,
    title: 'Tort botez 158',
    description: 'Descriere tort botez 158',
    image: '/images/baptism-cakes/00158.webp',
    type: 'baptismCakes',
  },
  {
    id: 159,
    title: 'Tort botez 159',
    description: 'Descriere tort botez 159',
    image: '/images/baptism-cakes/00159.webp',
    type: 'baptismCakes',
  },
  {
    id: 160,
    title: 'Tort botez 160',
    description: 'Descriere tort botez 160',
    image: '/images/baptism-cakes/00160.webp',
    type: 'baptismCakes',
  },
  {
    id: 161,
    title: 'Tort botez 161',
    description: 'Descriere tort botez 161',
    image: '/images/baptism-cakes/00161.webp',
    type: 'baptismCakes',
  },
  {
    id: 162,
    title: 'Tort botez 162',
    description: 'Descriere tort botez 162',
    image: '/images/baptism-cakes/00162.webp',
    type: 'baptismCakes',
  },
  {
    id: 163,
    title: 'Tort botez 163',
    description: 'Descriere tort botez 163',
    image: '/images/baptism-cakes/00163.webp',
    type: 'baptismCakes',
  },
  {
    id: 164,
    title: 'Tort botez 164',
    description: 'Descriere tort botez 164',
    image: '/images/baptism-cakes/00164.webp',
    type: 'baptismCakes',
  },
  {
    id: 165,
    title: 'Tort botez 165',
    description: 'Descriere tort botez 165',
    image: '/images/baptism-cakes/00165.webp',
    type: 'baptismCakes',
  },
  {
    id: 166,
    title: 'Tort botez 166',
    description: 'Descriere tort botez 166',
    image: '/images/baptism-cakes/00166.webp',
    type: 'baptismCakes',
  },
  {
    id: 167,
    title: 'Tort botez 167',
    description: 'Descriere tort botez 167',
    image: '/images/baptism-cakes/00167.webp',
    type: 'baptismCakes',
  },
  {
    id: 168,
    title: 'Tort botez 168',
    description: 'Descriere tort botez 168',
    image: '/images/baptism-cakes/00168.webp',
    type: 'baptismCakes',
  },
  {
    id: 169,
    title: 'Tort botez 169',
    description: 'Descriere tort botez 169',
    image: '/images/baptism-cakes/00169.webp',
    type: 'baptismCakes',
  },
  {
    id: 170,
    title: 'Tort botez 170',
    description: 'Descriere tort botez 170',
    image: '/images/baptism-cakes/00170.webp',
    type: 'baptismCakes',
  },
  {
    id: 171,
    title: 'Tort botez 171',
    description: 'Descriere tort botez 171',
    image: '/images/baptism-cakes/00171.webp',
    type: 'baptismCakes',
  },
  {
    id: 172,
    title: 'Tort botez 172',
    description: 'Descriere tort botez 172',
    image: '/images/baptism-cakes/00172.webp',
    type: 'baptismCakes',
  },
  {
    id: 173,
    title: 'Tort botez 173',
    description: 'Descriere tort botez 173',
    image: '/images/baptism-cakes/00173.webp',
    type: 'baptismCakes',
  },
  {
    id: 174,
    title: 'Tort botez 174',
    description: 'Descriere tort botez 174',
    image: '/images/baptism-cakes/00174.webp',
    type: 'baptismCakes',
  },
  {
    id: 175,
    title: 'Tort botez 175',
    description: 'Descriere tort botez 175',
    image: '/images/baptism-cakes/00175.webp',
    type: 'baptismCakes',
  },
  {
    id: 176,
    title: 'Tort botez 176',
    description: 'Descriere tort botez 176',
    image: '/images/baptism-cakes/00176.webp',
    type: 'baptismCakes',
  },
  {
    id: 177,
    title: 'Tort botez 177',
    description: 'Descriere tort botez 177',
    image: '/images/baptism-cakes/00177.webp',
    type: 'baptismCakes',
  },
  {
    id: 178,
    title: 'Tort botez 178',
    description: 'Descriere tort botez 178',
    image: '/images/baptism-cakes/00178.webp',
    type: 'baptismCakes',
  },
  {
    id: 179,
    title: 'Tort aniversare 1',
    description: 'Descriere tort aniversare 1',
    image: '/images/birthday-cakes/00001.webp',
    type: 'birthdayCakes',
  },
  {
    id: 180,
    title: 'Tort aniversare 2',
    description: 'Descriere tort aniversare 2',
    image: '/images/birthday-cakes/00002.webp',
    type: 'birthdayCakes',
  },
  {
    id: 181,
    title: 'Tort aniversare 3',
    description: 'Descriere tort aniversare 3',
    image: '/images/birthday-cakes/00003.webp',
    type: 'birthdayCakes',
  },
  {
    id: 182,
    title: 'Tort aniversare 4',
    description: 'Descriere tort aniversare 4',
    image: '/images/birthday-cakes/00004.webp',
    type: 'birthdayCakes',
  },
  {
    id: 183,
    title: 'Tort aniversare 5',
    description: 'Descriere tort aniversare 5',
    image: '/images/birthday-cakes/00005.webp',
    type: 'birthdayCakes',
  },
  {
    id: 184,
    title: 'Tort aniversare 6',
    description: 'Descriere tort aniversare 6',
    image: '/images/birthday-cakes/00006.webp',
    type: 'birthdayCakes',
  },
  {
    id: 185,
    title: 'Tort aniversare 7',
    description: 'Descriere tort aniversare 7',
    image: '/images/birthday-cakes/00007.webp',
    type: 'birthdayCakes',
  },
  {
    id: 186,
    title: 'Tort aniversare 8',
    description: 'Descriere tort aniversare 8',
    image: '/images/birthday-cakes/00008.webp',
    type: 'birthdayCakes',
  },
  {
    id: 187,
    title: 'Tort aniversare 9',
    description: 'Descriere tort aniversare 9',
    image: '/images/birthday-cakes/00009.webp',
    type: 'birthdayCakes',
  },
  {
    id: 188,
    title: 'Tort aniversare 10',
    description: 'Descriere tort aniversare 10',
    image: '/images/birthday-cakes/00010.webp',
    type: 'birthdayCakes',
  },
  {
    id: 189,
    title: 'Tort aniversare 11',
    description: 'Descriere tort aniversare 11',
    image: '/images/birthday-cakes/00011.webp',
    type: 'birthdayCakes',
  },
  {
    id: 190,
    title: 'Tort aniversare 12',
    description: 'Descriere tort aniversare 12',
    image: '/images/birthday-cakes/00012.webp',
    type: 'birthdayCakes',
  },
  {
    id: 191,
    title: 'Tort aniversare 13',
    description: 'Descriere tort aniversare 13',
    image: '/images/birthday-cakes/00013.webp',
    type: 'birthdayCakes',
  },
  {
    id: 192,
    title: 'Tort aniversare 14',
    description: 'Descriere tort aniversare 14',
    image: '/images/birthday-cakes/00014.webp',
    type: 'birthdayCakes',
  },
  {
    id: 193,
    title: 'Tort aniversare 15',
    description: 'Descriere tort aniversare 15',
    image: '/images/birthday-cakes/00015.webp',
    type: 'birthdayCakes',
  },
  {
    id: 194,
    title: 'Tort aniversare 16',
    description: 'Descriere tort aniversare 16',
    image: '/images/birthday-cakes/00016.webp',
    type: 'birthdayCakes',
  },
  {
    id: 195,
    title: 'Tort aniversare 17',
    description: 'Descriere tort aniversare 17',
    image: '/images/birthday-cakes/00017.webp',
    type: 'birthdayCakes',
  },
  {
    id: 196,
    title: 'Tort aniversare 18',
    description: 'Descriere tort aniversare 18',
    image: '/images/birthday-cakes/00018.webp',
    type: 'birthdayCakes',
  },
  {
    id: 197,
    title: 'Tort aniversare 19',
    description: 'Descriere tort aniversare 19',
    image: '/images/birthday-cakes/00019.webp',
    type: 'birthdayCakes',
  },
  {
    id: 198,
    title: 'Tort aniversare 20',
    description: 'Descriere tort aniversare 20',
    image: '/images/birthday-cakes/00020.webp',
    type: 'birthdayCakes',
  },
  {
    id: 199,
    title: 'Tort aniversare 21',
    description: 'Descriere tort aniversare 21',
    image: '/images/birthday-cakes/00021.webp',
    type: 'birthdayCakes',
  },
  {
    id: 200,
    title: 'Tort aniversare 22',
    description: 'Descriere tort aniversare 22',
    image: '/images/birthday-cakes/00022.webp',
    type: 'birthdayCakes',
  },
  {
    id: 201,
    title: 'Tort aniversare 23',
    description: 'Descriere tort aniversare 23',
    image: '/images/birthday-cakes/00023.webp',
    type: 'birthdayCakes',
  },
  {
    id: 202,
    title: 'Tort aniversare 24',
    description: 'Descriere tort aniversare 24',
    image: '/images/birthday-cakes/00024.webp',
    type: 'birthdayCakes',
  },
  {
    id: 203,
    title: 'Tort aniversare 25',
    description: 'Descriere tort aniversare 25',
    image: '/images/birthday-cakes/00025.webp',
    type: 'birthdayCakes',
  },
  {
    id: 204,
    title: 'Tort aniversare 26',
    description: 'Descriere tort aniversare 26',
    image: '/images/birthday-cakes/00026.webp',
    type: 'birthdayCakes',
  },
  {
    id: 205,
    title: 'Tort aniversare 27',
    description: 'Descriere tort aniversare 27',
    image: '/images/birthday-cakes/00027.webp',
    type: 'birthdayCakes',
  },
  {
    id: 206,
    title: 'Tort aniversare 28',
    description: 'Descriere tort aniversare 28',
    image: '/images/birthday-cakes/00028.webp',
    type: 'birthdayCakes',
  },
  {
    id: 207,
    title: 'Tort aniversare 29',
    description: 'Descriere tort aniversare 29',
    image: '/images/birthday-cakes/00029.webp',
    type: 'birthdayCakes',
  },
  {
    id: 208,
    title: 'Tort aniversare 30',
    description: 'Descriere tort aniversare 30',
    image: '/images/birthday-cakes/00030.webp',
    type: 'birthdayCakes',
  },
  {
    id: 209,
    title: 'Tort aniversare 31',
    description: 'Descriere tort aniversare 31',
    image: '/images/birthday-cakes/00031.webp',
    type: 'birthdayCakes',
  },
  {
    id: 210,
    title: 'Tort aniversare 32',
    description: 'Descriere tort aniversare 32',
    image: '/images/birthday-cakes/00032.webp',
    type: 'birthdayCakes',
  },
  {
    id: 211,
    title: 'Tort aniversare 33',
    description: 'Descriere tort aniversare 33',
    image: '/images/birthday-cakes/00033.webp',
    type: 'birthdayCakes',
  },
  {
    id: 212,
    title: 'Tort aniversare 34',
    description: 'Descriere tort aniversare 34',
    image: '/images/birthday-cakes/00034.webp',
    type: 'birthdayCakes',
  },
  {
    id: 213,
    title: 'Tort aniversare 35',
    description: 'Descriere tort aniversare 35',
    image: '/images/birthday-cakes/00035.webp',
    type: 'birthdayCakes',
  },
  {
    id: 214,
    title: 'Tort aniversare 36',
    description: 'Descriere tort aniversare 36',
    image: '/images/birthday-cakes/00036.webp',
    type: 'birthdayCakes',
  },
  {
    id: 215,
    title: 'Tort aniversare 37',
    description: 'Descriere tort aniversare 37',
    image: '/images/birthday-cakes/00037.webp',
    type: 'birthdayCakes',
  },
  {
    id: 216,
    title: 'Tort aniversare 38',
    description: 'Descriere tort aniversare 38',
    image: '/images/birthday-cakes/00038.webp',
    type: 'birthdayCakes',
  },
  {
    id: 217,
    title: 'Tort aniversare 39',
    description: 'Descriere tort aniversare 39',
    image: '/images/birthday-cakes/00039.webp',
    type: 'birthdayCakes',
  },
  {
    id: 218,
    title: 'Tort aniversare 40',
    description: 'Descriere tort aniversare 40',
    image: '/images/birthday-cakes/00040.webp',
    type: 'birthdayCakes',
  },
  {
    id: 219,
    title: 'Tort aniversare 41',
    description: 'Descriere tort aniversare 41',
    image: '/images/birthday-cakes/00041.webp',
    type: 'birthdayCakes',
  },
  {
    id: 220,
    title: 'Tort aniversare 42',
    description: 'Descriere tort aniversare 42',
    image: '/images/birthday-cakes/00042.webp',
    type: 'birthdayCakes',
  },
  {
    id: 221,
    title: 'Tort aniversare 43',
    description: 'Descriere tort aniversare 43',
    image: '/images/birthday-cakes/00043.webp',
    type: 'birthdayCakes',
  },
  {
    id: 222,
    title: 'Tort aniversare 44',
    description: 'Descriere tort aniversare 44',
    image: '/images/birthday-cakes/00044.webp',
    type: 'birthdayCakes',
  },
  {
    id: 223,
    title: 'Tort aniversare 45',
    description: 'Descriere tort aniversare 45',
    image: '/images/birthday-cakes/00045.webp',
    type: 'birthdayCakes',
  },
  {
    id: 224,
    title: 'Tort aniversare 46',
    description: 'Descriere tort aniversare 46',
    image: '/images/birthday-cakes/00046.webp',
    type: 'birthdayCakes',
  },
  {
    id: 225,
    title: 'Tort aniversare 47',
    description: 'Descriere tort aniversare 47',
    image: '/images/birthday-cakes/00047.webp',
    type: 'birthdayCakes',
  },
  {
    id: 226,
    title: 'Tort aniversare 48',
    description: 'Descriere tort aniversare 48',
    image: '/images/birthday-cakes/00048.webp',
    type: 'birthdayCakes',
  },
  {
    id: 227,
    title: 'Tort aniversare 49',
    description: 'Descriere tort aniversare 49',
    image: '/images/birthday-cakes/00049.webp',
    type: 'birthdayCakes',
  },
  {
    id: 228,
    title: 'Tort aniversare 50',
    description: 'Descriere tort aniversare 50',
    image: '/images/birthday-cakes/00050.webp',
    type: 'birthdayCakes',
  },
  {
    id: 229,
    title: 'Tort aniversare 51',
    description: 'Descriere tort aniversare 51',
    image: '/images/birthday-cakes/00051.webp',
    type: 'birthdayCakes',
  },
  {
    id: 230,
    title: 'Tort aniversare 52',
    description: 'Descriere tort aniversare 52',
    image: '/images/birthday-cakes/00052.webp',
    type: 'birthdayCakes',
  },
  {
    id: 231,
    title: 'Tort aniversare 53',
    description: 'Descriere tort aniversare 53',
    image: '/images/birthday-cakes/00053.webp',
    type: 'birthdayCakes',
  },
  {
    id: 232,
    title: 'Tort aniversare 54',
    description: 'Descriere tort aniversare 54',
    image: '/images/birthday-cakes/00054.webp',
    type: 'birthdayCakes',
  },
  {
    id: 233,
    title: 'Tort aniversare 55',
    description: 'Descriere tort aniversare 55',
    image: '/images/birthday-cakes/00055.webp',
    type: 'birthdayCakes',
  },
  {
    id: 234,
    title: 'Tort aniversare 56',
    description: 'Descriere tort aniversare 56',
    image: '/images/birthday-cakes/00056.webp',
    type: 'birthdayCakes',
  },
  {
    id: 235,
    title: 'Tort aniversare 57',
    description: 'Descriere tort aniversare 57',
    image: '/images/birthday-cakes/00057.webp',
    type: 'birthdayCakes',
  },
  {
    id: 236,
    title: 'Tort aniversare 58',
    description: 'Descriere tort aniversare 58',
    image: '/images/birthday-cakes/00058.webp',
    type: 'birthdayCakes',
  },
  {
    id: 237,
    title: 'Tort aniversare 59',
    description: 'Descriere tort aniversare 59',
    image: '/images/birthday-cakes/00059.webp',
    type: 'birthdayCakes',
  },
  {
    id: 238,
    title: 'Tort aniversare 60',
    description: 'Descriere tort aniversare 60',
    image: '/images/birthday-cakes/00060.webp',
    type: 'birthdayCakes',
  },
  {
    id: 239,
    title: 'Tort aniversare 61',
    description: 'Descriere tort aniversare 61',
    image: '/images/birthday-cakes/00061.webp',
    type: 'birthdayCakes',
  },
  {
    id: 240,
    title: 'Tort aniversare 62',
    description: 'Descriere tort aniversare 62',
    image: '/images/birthday-cakes/00062.webp',
    type: 'birthdayCakes',
  },
  {
    id: 241,
    title: 'Tort aniversare 63',
    description: 'Descriere tort aniversare 63',
    image: '/images/birthday-cakes/00063.webp',
    type: 'birthdayCakes',
  },
  {
    id: 242,
    title: 'Tort aniversare 64',
    description: 'Descriere tort aniversare 64',
    image: '/images/birthday-cakes/00064.webp',
    type: 'birthdayCakes',
  },
  {
    id: 243,
    title: 'Tort aniversare 65',
    description: 'Descriere tort aniversare 65',
    image: '/images/birthday-cakes/00065.webp',
    type: 'birthdayCakes',
  },
  {
    id: 244,
    title: 'Tort aniversare 66',
    description: 'Descriere tort aniversare 66',
    image: '/images/birthday-cakes/00066.webp',
    type: 'birthdayCakes',
  },
  {
    id: 245,
    title: 'Tort aniversare 67',
    description: 'Descriere tort aniversare 67',
    image: '/images/birthday-cakes/00067.webp',
    type: 'birthdayCakes',
  },
  {
    id: 246,
    title: 'Tort aniversare 68',
    description: 'Descriere tort aniversare 68',
    image: '/images/birthday-cakes/00068.webp',
    type: 'birthdayCakes',
  },
  {
    id: 247,
    title: 'Tort aniversare 69',
    description: 'Descriere tort aniversare 69',
    image: '/images/birthday-cakes/00069.webp',
    type: 'birthdayCakes',
  },
  {
    id: 248,
    title: 'Tort aniversare 70',
    description: 'Descriere tort aniversare 70',
    image: '/images/birthday-cakes/00070.webp',
    type: 'birthdayCakes',
  },
  {
    id: 249,
    title: 'Tort aniversare 71',
    description: 'Descriere tort aniversare 71',
    image: '/images/birthday-cakes/00071.webp',
    type: 'birthdayCakes',
  },
  {
    id: 250,
    title: 'Tort aniversare 72',
    description: 'Descriere tort aniversare 72',
    image: '/images/birthday-cakes/00072.webp',
    type: 'birthdayCakes',
  },
  {
    id: 251,
    title: 'Tort aniversare 73',
    description: 'Descriere tort aniversare 73',
    image: '/images/birthday-cakes/00073.webp',
    type: 'birthdayCakes',
  },
  {
    id: 252,
    title: 'Tort aniversare 74',
    description: 'Descriere tort aniversare 74',
    image: '/images/birthday-cakes/00074.webp',
    type: 'birthdayCakes',
  },
  {
    id: 253,
    title: 'Tort aniversare 75',
    description: 'Descriere tort aniversare 75',
    image: '/images/birthday-cakes/00075.webp',
    type: 'birthdayCakes',
  },
  {
    id: 254,
    title: 'Tort aniversare 76',
    description: 'Descriere tort aniversare 76',
    image: '/images/birthday-cakes/00076.webp',
    type: 'birthdayCakes',
  },
  {
    id: 255,
    title: 'Tort aniversare 77',
    description: 'Descriere tort aniversare 77',
    image: '/images/birthday-cakes/00077.webp',
    type: 'birthdayCakes',
  },
  {
    id: 256,
    title: 'Tort aniversare 78',
    description: 'Descriere tort aniversare 78',
    image: '/images/birthday-cakes/00078.webp',
    type: 'birthdayCakes',
  },
  {
    id: 257,
    title: 'Tort aniversare 79',
    description: 'Descriere tort aniversare 79',
    image: '/images/birthday-cakes/00079.webp',
    type: 'birthdayCakes',
  },
  {
    id: 258,
    title: 'Tort aniversare 80',
    description: 'Descriere tort aniversare 80',
    image: '/images/birthday-cakes/00080.webp',
    type: 'birthdayCakes',
  },
  {
    id: 259,
    title: 'Tort aniversare 81',
    description: 'Descriere tort aniversare 81',
    image: '/images/birthday-cakes/00081.webp',
    type: 'birthdayCakes',
  },
  {
    id: 260,
    title: 'Tort aniversare 82',
    description: 'Descriere tort aniversare 82',
    image: '/images/birthday-cakes/00082.webp',
    type: 'birthdayCakes',
  },
  {
    id: 261,
    title: 'Tort aniversare 83',
    description: 'Descriere tort aniversare 83',
    image: '/images/birthday-cakes/00083.webp',
    type: 'birthdayCakes',
  },
  {
    id: 262,
    title: 'Tort aniversare 84',
    description: 'Descriere tort aniversare 84',
    image: '/images/birthday-cakes/00084.webp',
    type: 'birthdayCakes',
  },
  {
    id: 263,
    title: 'Tort aniversare 85',
    description: 'Descriere tort aniversare 85',
    image: '/images/birthday-cakes/00085.webp',
    type: 'birthdayCakes',
  },
  {
    id: 264,
    title: 'Tort aniversare 86',
    description: 'Descriere tort aniversare 86',
    image: '/images/birthday-cakes/00086.webp',
    type: 'birthdayCakes',
  },
  {
    id: 265,
    title: 'Tort aniversare 87',
    description: 'Descriere tort aniversare 87',
    image: '/images/birthday-cakes/00087.webp',
    type: 'birthdayCakes',
  },
  {
    id: 266,
    title: 'Tort aniversare 88',
    description: 'Descriere tort aniversare 88',
    image: '/images/birthday-cakes/00088.webp',
    type: 'birthdayCakes',
  },
  {
    id: 267,
    title: 'Tort aniversare 89',
    description: 'Descriere tort aniversare 89',
    image: '/images/birthday-cakes/00089.webp',
    type: 'birthdayCakes',
  },
  {
    id: 268,
    title: 'Tort aniversare 90',
    description: 'Descriere tort aniversare 90',
    image: '/images/birthday-cakes/00090.webp',
    type: 'birthdayCakes',
  },
  {
    id: 269,
    title: 'Tort aniversare 91',
    description: 'Descriere tort aniversare 91',
    image: '/images/birthday-cakes/00091.webp',
    type: 'birthdayCakes',
  },
  {
    id: 270,
    title: 'Tort aniversare 92',
    description: 'Descriere tort aniversare 92',
    image: '/images/birthday-cakes/00092.webp',
    type: 'birthdayCakes',
  },
  {
    id: 271,
    title: 'Tort aniversare 93',
    description: 'Descriere tort aniversare 93',
    image: '/images/birthday-cakes/00093.webp',
    type: 'birthdayCakes',
  },
  {
    id: 272,
    title: 'Tort aniversare 94',
    description: 'Descriere tort aniversare 94',
    image: '/images/birthday-cakes/00094.webp',
    type: 'birthdayCakes',
  },
  {
    id: 273,
    title: 'Tort aniversare 95',
    description: 'Descriere tort aniversare 95',
    image: '/images/birthday-cakes/00095.webp',
    type: 'birthdayCakes',
  },
  {
    id: 274,
    title: 'Tort aniversare 96',
    description: 'Descriere tort aniversare 96',
    image: '/images/birthday-cakes/00096.webp',
    type: 'birthdayCakes',
  },
  {
    id: 275,
    title: 'Tort aniversare 97',
    description: 'Descriere tort aniversare 97',
    image: '/images/birthday-cakes/00097.webp',
    type: 'birthdayCakes',
  },
  {
    id: 276,
    title: 'Tort aniversare 98',
    description: 'Descriere tort aniversare 98',
    image: '/images/birthday-cakes/00098.webp',
    type: 'birthdayCakes',
  },
  {
    id: 277,
    title: 'Tort aniversare 99',
    description: 'Descriere tort aniversare 99',
    image: '/images/birthday-cakes/00099.webp',
    type: 'birthdayCakes',
  },
  {
    id: 278,
    title: 'Tort aniversare 100',
    description: 'Descriere tort aniversare 100',
    image: '/images/birthday-cakes/00100.webp',
    type: 'birthdayCakes',
  },
  {
    id: 279,
    title: 'Tort aniversare 101',
    description: 'Descriere tort aniversare 101',
    image: '/images/birthday-cakes/00101.webp',
    type: 'birthdayCakes',
  },
  {
    id: 280,
    title: 'Tort aniversare 102',
    description: 'Descriere tort aniversare 102',
    image: '/images/birthday-cakes/00102.webp',
    type: 'birthdayCakes',
  },
  {
    id: 281,
    title: 'Tort aniversare 103',
    description: 'Descriere tort aniversare 103',
    image: '/images/birthday-cakes/00103.webp',
    type: 'birthdayCakes',
  },
  {
    id: 282,
    title: 'Tort aniversare 104',
    description: 'Descriere tort aniversare 104',
    image: '/images/birthday-cakes/00104.webp',
    type: 'birthdayCakes',
  },
  {
    id: 283,
    title: 'Tort aniversare 105',
    description: 'Descriere tort aniversare 105',
    image: '/images/birthday-cakes/00105.webp',
    type: 'birthdayCakes',
  },
  {
    id: 284,
    title: 'Tort aniversare 106',
    description: 'Descriere tort aniversare 106',
    image: '/images/birthday-cakes/00106.webp',
    type: 'birthdayCakes',
  },
  {
    id: 285,
    title: 'Tort aniversare 107',
    description: 'Descriere tort aniversare 107',
    image: '/images/birthday-cakes/00107.webp',
    type: 'birthdayCakes',
  },
  {
    id: 286,
    title: 'Tort aniversare 108',
    description: 'Descriere tort aniversare 108',
    image: '/images/birthday-cakes/00108.webp',
    type: 'birthdayCakes',
  },
  {
    id: 287,
    title: 'Tort aniversare 109',
    description: 'Descriere tort aniversare 109',
    image: '/images/birthday-cakes/00109.webp',
    type: 'birthdayCakes',
  },
  {
    id: 288,
    title: 'Tort aniversare 110',
    description: 'Descriere tort aniversare 110',
    image: '/images/birthday-cakes/00110.webp',
    type: 'birthdayCakes',
  },
  {
    id: 289,
    title: 'Tort aniversare 111',
    description: 'Descriere tort aniversare 111',
    image: '/images/birthday-cakes/00111.webp',
    type: 'birthdayCakes',
  },
  {
    id: 290,
    title: 'Tort aniversare 112',
    description: 'Descriere tort aniversare 112',
    image: '/images/birthday-cakes/00112.webp',
    type: 'birthdayCakes',
  },
  {
    id: 291,
    title: 'Tort aniversare 113',
    description: 'Descriere tort aniversare 113',
    image: '/images/birthday-cakes/00113.webp',
    type: 'birthdayCakes',
  },
  {
    id: 292,
    title: 'Tort aniversare 114',
    description: 'Descriere tort aniversare 114',
    image: '/images/birthday-cakes/00114.webp',
    type: 'birthdayCakes',
  },
  {
    id: 293,
    title: 'Tort aniversare 115',
    description: 'Descriere tort aniversare 115',
    image: '/images/birthday-cakes/00115.webp',
    type: 'birthdayCakes',
  },
  {
    id: 294,
    title: 'Tort aniversare 116',
    description: 'Descriere tort aniversare 116',
    image: '/images/birthday-cakes/00116.webp',
    type: 'birthdayCakes',
  },
  {
    id: 295,
    title: 'Tort aniversare 117',
    description: 'Descriere tort aniversare 117',
    image: '/images/birthday-cakes/00117.webp',
    type: 'birthdayCakes',
  },
  {
    id: 296,
    title: 'Tort aniversare 118',
    description: 'Descriere tort aniversare 118',
    image: '/images/birthday-cakes/00118.webp',
    type: 'birthdayCakes',
  },
  {
    id: 297,
    title: 'Tort aniversare 119',
    description: 'Descriere tort aniversare 119',
    image: '/images/birthday-cakes/00119.webp',
    type: 'birthdayCakes',
  },
  {
    id: 298,
    title: 'Tort aniversare 120',
    description: 'Descriere tort aniversare 120',
    image: '/images/birthday-cakes/00120.webp',
    type: 'birthdayCakes',
  },
  {
    id: 299,
    title: 'Tort aniversare 121',
    description: 'Descriere tort aniversare 121',
    image: '/images/birthday-cakes/00121.webp',
    type: 'birthdayCakes',
  },
  {
    id: 300,
    title: 'Tort aniversare 122',
    description: 'Descriere tort aniversare 122',
    image: '/images/birthday-cakes/00122.webp',
    type: 'birthdayCakes',
  },
  {
    id: 301,
    title: 'Tort aniversare 123',
    description: 'Descriere tort aniversare 123',
    image: '/images/birthday-cakes/00123.webp',
    type: 'birthdayCakes',
  },
  {
    id: 302,
    title: 'Tort aniversare 124',
    description: 'Descriere tort aniversare 124',
    image: '/images/birthday-cakes/00124.webp',
    type: 'birthdayCakes',
  },
  {
    id: 303,
    title: 'Tort aniversare 125',
    description: 'Descriere tort aniversare 125',
    image: '/images/birthday-cakes/00125.webp',
    type: 'birthdayCakes',
  },
  {
    id: 304,
    title: 'Tort aniversare 126',
    description: 'Descriere tort aniversare 126',
    image: '/images/birthday-cakes/00126.webp',
    type: 'birthdayCakes',
  },
  {
    id: 305,
    title: 'Tort aniversare 127',
    description: 'Descriere tort aniversare 127',
    image: '/images/birthday-cakes/00127.webp',
    type: 'birthdayCakes',
  },
  {
    id: 306,
    title: 'Tort aniversare 128',
    description: 'Descriere tort aniversare 128',
    image: '/images/birthday-cakes/00128.webp',
    type: 'birthdayCakes',
  },
  {
    id: 307,
    title: 'Tort aniversare 129',
    description: 'Descriere tort aniversare 129',
    image: '/images/birthday-cakes/00129.webp',
    type: 'birthdayCakes',
  },
  {
    id: 308,
    title: 'Tort aniversare 130',
    description: 'Descriere tort aniversare 130',
    image: '/images/birthday-cakes/00130.webp',
    type: 'birthdayCakes',
  },
  {
    id: 309,
    title: 'Tort aniversare 131',
    description: 'Descriere tort aniversare 131',
    image: '/images/birthday-cakes/00131.webp',
    type: 'birthdayCakes',
  },
  {
    id: 310,
    title: 'Tort aniversare 132',
    description: 'Descriere tort aniversare 132',
    image: '/images/birthday-cakes/00132.webp',
    type: 'birthdayCakes',
  },
  {
    id: 311,
    title: 'Tort aniversare 133',
    description: 'Descriere tort aniversare 133',
    image: '/images/birthday-cakes/00133.webp',
    type: 'birthdayCakes',
  },
  {
    id: 312,
    title: 'Tort aniversare 134',
    description: 'Descriere tort aniversare 134',
    image: '/images/birthday-cakes/00134.webp',
    type: 'birthdayCakes',
  },
  {
    id: 313,
    title: 'Tort aniversare 135',
    description: 'Descriere tort aniversare 135',
    image: '/images/birthday-cakes/00135.webp',
    type: 'birthdayCakes',
  },
  {
    id: 314,
    title: 'Tort aniversare 136',
    description: 'Descriere tort aniversare 136',
    image: '/images/birthday-cakes/00136.webp',
    type: 'birthdayCakes',
  },
  {
    id: 315,
    title: 'Tort aniversare 137',
    description: 'Descriere tort aniversare 137',
    image: '/images/birthday-cakes/00137.webp',
    type: 'birthdayCakes',
  },
  {
    id: 316,
    title: 'Tort aniversare 138',
    description: 'Descriere tort aniversare 138',
    image: '/images/birthday-cakes/00138.webp',
    type: 'birthdayCakes',
  },
  {
    id: 317,
    title: 'Tort aniversare 139',
    description: 'Descriere tort aniversare 139',
    image: '/images/birthday-cakes/00139.webp',
    type: 'birthdayCakes',
  },
  {
    id: 318,
    title: 'Tort aniversare 140',
    description: 'Descriere tort aniversare 140',
    image: '/images/birthday-cakes/00140.webp',
    type: 'birthdayCakes',
  },
  {
    id: 319,
    title: 'Tort aniversare 141',
    description: 'Descriere tort aniversare 141',
    image: '/images/birthday-cakes/00141.webp',
    type: 'birthdayCakes',
  },
  {
    id: 320,
    title: 'Tort aniversare 142',
    description: 'Descriere tort aniversare 142',
    image: '/images/birthday-cakes/00142.webp',
    type: 'birthdayCakes',
  },
  {
    id: 321,
    title: 'Tort aniversare 143',
    description: 'Descriere tort aniversare 143',
    image: '/images/birthday-cakes/00143.webp',
    type: 'birthdayCakes',
  },
  {
    id: 322,
    title: 'Tort aniversare 144',
    description: 'Descriere tort aniversare 144',
    image: '/images/birthday-cakes/00144.webp',
    type: 'birthdayCakes',
  },
  {
    id: 323,
    title: 'Tort aniversare 145',
    description: 'Descriere tort aniversare 145',
    image: '/images/birthday-cakes/00145.webp',
    type: 'birthdayCakes',
  },
  {
    id: 324,
    title: 'Tort aniversare 146',
    description: 'Descriere tort aniversare 146',
    image: '/images/birthday-cakes/00146.webp',
    type: 'birthdayCakes',
  },
  {
    id: 325,
    title: 'Tort aniversare 147',
    description: 'Descriere tort aniversare 147',
    image: '/images/birthday-cakes/00147.webp',
    type: 'birthdayCakes',
  },
  {
    id: 326,
    title: 'Tort aniversare 148',
    description: 'Descriere tort aniversare 148',
    image: '/images/birthday-cakes/00148.webp',
    type: 'birthdayCakes',
  },
  {
    id: 327,
    title: 'Tort aniversare 149',
    description: 'Descriere tort aniversare 149',
    image: '/images/birthday-cakes/00149.webp',
    type: 'birthdayCakes',
  },
  {
    id: 328,
    title: 'Tort aniversare 150',
    description: 'Descriere tort aniversare 150',
    image: '/images/birthday-cakes/00150.webp',
    type: 'birthdayCakes',
  },
  {
    id: 329,
    title: 'Tort aniversare 151',
    description: 'Descriere tort aniversare 151',
    image: '/images/birthday-cakes/00151.webp',
    type: 'birthdayCakes',
  },
  {
    id: 330,
    title: 'Tort aniversare 152',
    description: 'Descriere tort aniversare 152',
    image: '/images/birthday-cakes/00152.webp',
    type: 'birthdayCakes',
  },
  {
    id: 331,
    title: 'Tort aniversare 153',
    description: 'Descriere tort aniversare 153',
    image: '/images/birthday-cakes/00153.webp',
    type: 'birthdayCakes',
  },
  {
    id: 332,
    title: 'Tort aniversare 154',
    description: 'Descriere tort aniversare 154',
    image: '/images/birthday-cakes/00154.webp',
    type: 'birthdayCakes',
  },
  {
    id: 333,
    title: 'Tort aniversare 155',
    description: 'Descriere tort aniversare 155',
    image: '/images/birthday-cakes/00155.webp',
    type: 'birthdayCakes',
  },
  {
    id: 334,
    title: 'Tort aniversare 156',
    description: 'Descriere tort aniversare 156',
    image: '/images/birthday-cakes/00156.webp',
    type: 'birthdayCakes',
  },
  {
    id: 335,
    title: 'Tort aniversare 157',
    description: 'Descriere tort aniversare 157',
    image: '/images/birthday-cakes/00157.webp',
    type: 'birthdayCakes',
  },
  {
    id: 336,
    title: 'Tort aniversare 158',
    description: 'Descriere tort aniversare 158',
    image: '/images/birthday-cakes/00158.webp',
    type: 'birthdayCakes',
  },
  {
    id: 337,
    title: 'Tort aniversare 159',
    description: 'Descriere tort aniversare 159',
    image: '/images/birthday-cakes/00159.webp',
    type: 'birthdayCakes',
  },
  {
    id: 338,
    title: 'Tort aniversare 160',
    description: 'Descriere tort aniversare 160',
    image: '/images/birthday-cakes/00160.webp',
    type: 'birthdayCakes',
  },
  {
    id: 339,
    title: 'Tort aniversare 161',
    description: 'Descriere tort aniversare 161',
    image: '/images/birthday-cakes/00161.webp',
    type: 'birthdayCakes',
  },
  {
    id: 340,
    title: 'Tort aniversare 162',
    description: 'Descriere tort aniversare 162',
    image: '/images/birthday-cakes/00162.webp',
    type: 'birthdayCakes',
  },
  {
    id: 341,
    title: 'Tort aniversare 163',
    description: 'Descriere tort aniversare 163',
    image: '/images/birthday-cakes/00163.webp',
    type: 'birthdayCakes',
  },
  {
    id: 342,
    title: 'Tort aniversare 164',
    description: 'Descriere tort aniversare 164',
    image: '/images/birthday-cakes/00164.webp',
    type: 'birthdayCakes',
  },
  {
    id: 343,
    title: 'Tort aniversare 165',
    description: 'Descriere tort aniversare 165',
    image: '/images/birthday-cakes/00165.webp',
    type: 'birthdayCakes',
  },
  {
    id: 344,
    title: 'Tort aniversare 166',
    description: 'Descriere tort aniversare 166',
    image: '/images/birthday-cakes/00166.webp',
    type: 'birthdayCakes',
  },
  {
    id: 345,
    title: 'Tort aniversare 167',
    description: 'Descriere tort aniversare 167',
    image: '/images/birthday-cakes/00167.webp',
    type: 'birthdayCakes',
  },
  {
    id: 346,
    title: 'Tort aniversare 168',
    description: 'Descriere tort aniversare 168',
    image: '/images/birthday-cakes/00168.webp',
    type: 'birthdayCakes',
  },
  {
    id: 347,
    title: 'Tort aniversare 169',
    description: 'Descriere tort aniversare 169',
    image: '/images/birthday-cakes/00169.webp',
    type: 'birthdayCakes',
  },
  {
    id: 348,
    title: 'Tort aniversare 170',
    description: 'Descriere tort aniversare 170',
    image: '/images/birthday-cakes/00170.webp',
    type: 'birthdayCakes',
  },
  {
    id: 349,
    title: 'Tort aniversare 171',
    description: 'Descriere tort aniversare 171',
    image: '/images/birthday-cakes/00171.webp',
    type: 'birthdayCakes',
  },
  {
    id: 350,
    title: 'Tort aniversare 172',
    description: 'Descriere tort aniversare 172',
    image: '/images/birthday-cakes/00172.webp',
    type: 'birthdayCakes',
  },
  {
    id: 351,
    title: 'Tort aniversare 173',
    description: 'Descriere tort aniversare 173',
    image: '/images/birthday-cakes/00173.webp',
    type: 'birthdayCakes',
  },
  {
    id: 352,
    title: 'Tort aniversare 174',
    description: 'Descriere tort aniversare 174',
    image: '/images/birthday-cakes/00174.webp',
    type: 'birthdayCakes',
  },
  {
    id: 353,
    title: 'Tort aniversare 175',
    description: 'Descriere tort aniversare 175',
    image: '/images/birthday-cakes/00175.webp',
    type: 'birthdayCakes',
  },
  {
    id: 354,
    title: 'Tort aniversare 176',
    description: 'Descriere tort aniversare 176',
    image: '/images/birthday-cakes/00176.webp',
    type: 'birthdayCakes',
  },
  {
    id: 355,
    title: 'Tort aniversare 177',
    description: 'Descriere tort aniversare 177',
    image: '/images/birthday-cakes/00177.webp',
    type: 'birthdayCakes',
  },
  {
    id: 356,
    title: 'Tort aniversare 178',
    description: 'Descriere tort aniversare 178',
    image: '/images/birthday-cakes/00178.webp',
    type: 'birthdayCakes',
  },
  {
    id: 357,
    title: 'Tort aniversare 179',
    description: 'Descriere tort aniversare 179',
    image: '/images/birthday-cakes/00179.webp',
    type: 'birthdayCakes',
  },
  {
    id: 358,
    title: 'Tort aniversare 180',
    description: 'Descriere tort aniversare 180',
    image: '/images/birthday-cakes/00180.webp',
    type: 'birthdayCakes',
  },
  {
    id: 359,
    title: 'Tort aniversare 181',
    description: 'Descriere tort aniversare 181',
    image: '/images/birthday-cakes/00181.webp',
    type: 'birthdayCakes',
  },
  {
    id: 360,
    title: 'Tort aniversare 182',
    description: 'Descriere tort aniversare 182',
    image: '/images/birthday-cakes/00182.webp',
    type: 'birthdayCakes',
  },
  {
    id: 361,
    title: 'Tort aniversare 183',
    description: 'Descriere tort aniversare 183',
    image: '/images/birthday-cakes/00183.webp',
    type: 'birthdayCakes',
  },
  {
    id: 362,
    title: 'Tort aniversare 184',
    description: 'Descriere tort aniversare 184',
    image: '/images/birthday-cakes/00184.webp',
    type: 'birthdayCakes',
  },
  {
    id: 363,
    title: 'Tort aniversare 185',
    description: 'Descriere tort aniversare 185',
    image: '/images/birthday-cakes/00185.webp',
    type: 'birthdayCakes',
  },
  {
    id: 364,
    title: 'Tort aniversare 186',
    description: 'Descriere tort aniversare 186',
    image: '/images/birthday-cakes/00186.webp',
    type: 'birthdayCakes',
  },
  {
    id: 365,
    title: 'Tort aniversare 187',
    description: 'Descriere tort aniversare 187',
    image: '/images/birthday-cakes/00187.webp',
    type: 'birthdayCakes',
  },
  {
    id: 366,
    title: 'Tort aniversare 188',
    description: 'Descriere tort aniversare 188',
    image: '/images/birthday-cakes/00188.webp',
    type: 'birthdayCakes',
  },
  {
    id: 367,
    title: 'Tort aniversare 189',
    description: 'Descriere tort aniversare 189',
    image: '/images/birthday-cakes/00189.webp',
    type: 'birthdayCakes',
  },
  {
    id: 368,
    title: 'Tort aniversare 190',
    description: 'Descriere tort aniversare 190',
    image: '/images/birthday-cakes/00190.webp',
    type: 'birthdayCakes',
  },
  {
    id: 369,
    title: 'Tort aniversare 191',
    description: 'Descriere tort aniversare 191',
    image: '/images/birthday-cakes/00191.webp',
    type: 'birthdayCakes',
  },
  {
    id: 370,
    title: 'Tort aniversare 192',
    description: 'Descriere tort aniversare 192',
    image: '/images/birthday-cakes/00192.webp',
    type: 'birthdayCakes',
  },
  {
    id: 371,
    title: 'Tort aniversare 193',
    description: 'Descriere tort aniversare 193',
    image: '/images/birthday-cakes/00193.webp',
    type: 'birthdayCakes',
  },
  {
    id: 372,
    title: 'Tort aniversare 194',
    description: 'Descriere tort aniversare 194',
    image: '/images/birthday-cakes/00194.webp',
    type: 'birthdayCakes',
  },
  {
    id: 373,
    title: 'Tort aniversare 195',
    description: 'Descriere tort aniversare 195',
    image: '/images/birthday-cakes/00195.webp',
    type: 'birthdayCakes',
  },
  {
    id: 374,
    title: 'Tort aniversare 196',
    description: 'Descriere tort aniversare 196',
    image: '/images/birthday-cakes/00196.webp',
    type: 'birthdayCakes',
  },
  {
    id: 375,
    title: 'Tort aniversare 197',
    description: 'Descriere tort aniversare 197',
    image: '/images/birthday-cakes/00197.webp',
    type: 'birthdayCakes',
  },
  {
    id: 376,
    title: 'Tort aniversare 198',
    description: 'Descriere tort aniversare 198',
    image: '/images/birthday-cakes/00198.webp',
    type: 'birthdayCakes',
  },
  {
    id: 377,
    title: 'Tort aniversare 199',
    description: 'Descriere tort aniversare 199',
    image: '/images/birthday-cakes/00199.webp',
    type: 'birthdayCakes',
  },
  {
    id: 378,
    title: 'Tort aniversare 200',
    description: 'Descriere tort aniversare 200',
    image: '/images/birthday-cakes/00200.webp',
    type: 'birthdayCakes',
  },
  {
    id: 379,
    title: 'Tort aniversare 201',
    description: 'Descriere tort aniversare 201',
    image: '/images/birthday-cakes/00201.webp',
    type: 'birthdayCakes',
  },
  {
    id: 380,
    title: 'Tort aniversare 202',
    description: 'Descriere tort aniversare 202',
    image: '/images/birthday-cakes/00202.webp',
    type: 'birthdayCakes',
  },
  {
    id: 381,
    title: 'Tort aniversare 203',
    description: 'Descriere tort aniversare 203',
    image: '/images/birthday-cakes/00203.webp',
    type: 'birthdayCakes',
  },
  {
    id: 382,
    title: 'Tort aniversare 204',
    description: 'Descriere tort aniversare 204',
    image: '/images/birthday-cakes/00204.webp',
    type: 'birthdayCakes',
  },
  {
    id: 383,
    title: 'Tort aniversare 205',
    description: 'Descriere tort aniversare 205',
    image: '/images/birthday-cakes/00205.webp',
    type: 'birthdayCakes',
  },
  {
    id: 384,
    title: 'Tort aniversare 206',
    description: 'Descriere tort aniversare 206',
    image: '/images/birthday-cakes/00206.webp',
    type: 'birthdayCakes',
  },
  {
    id: 385,
    title: 'Tort aniversare 207',
    description: 'Descriere tort aniversare 207',
    image: '/images/birthday-cakes/00207.webp',
    type: 'birthdayCakes',
  },
  {
    id: 386,
    title: 'Tort aniversare 208',
    description: 'Descriere tort aniversare 208',
    image: '/images/birthday-cakes/00208.webp',
    type: 'birthdayCakes',
  },
  {
    id: 387,
    title: 'Tort aniversare 209',
    description: 'Descriere tort aniversare 209',
    image: '/images/birthday-cakes/00209.webp',
    type: 'birthdayCakes',
  },
  {
    id: 388,
    title: 'Tort aniversare 210',
    description: 'Descriere tort aniversare 210',
    image: '/images/birthday-cakes/00210.webp',
    type: 'birthdayCakes',
  },
  {
    id: 389,
    title: 'Tort aniversare 211',
    description: 'Descriere tort aniversare 211',
    image: '/images/birthday-cakes/00211.webp',
    type: 'birthdayCakes',
  },
  {
    id: 390,
    title: 'Tort aniversare 212',
    description: 'Descriere tort aniversare 212',
    image: '/images/birthday-cakes/00212.webp',
    type: 'birthdayCakes',
  },
  {
    id: 391,
    title: 'Tort aniversare 213',
    description: 'Descriere tort aniversare 213',
    image: '/images/birthday-cakes/00213.webp',
    type: 'birthdayCakes',
  },
  {
    id: 392,
    title: 'Tort aniversare 214',
    description: 'Descriere tort aniversare 214',
    image: '/images/birthday-cakes/00214.webp',
    type: 'birthdayCakes',
  },
  {
    id: 393,
    title: 'Tort aniversare 215',
    description: 'Descriere tort aniversare 215',
    image: '/images/birthday-cakes/00215.webp',
    type: 'birthdayCakes',
  },
  {
    id: 394,
    title: 'Tort aniversare 216',
    description: 'Descriere tort aniversare 216',
    image: '/images/birthday-cakes/00216.webp',
    type: 'birthdayCakes',
  },
  {
    id: 395,
    title: 'Tort aniversare 217',
    description: 'Descriere tort aniversare 217',
    image: '/images/birthday-cakes/00217.webp',
    type: 'birthdayCakes',
  },
  {
    id: 396,
    title: 'Tort aniversare 218',
    description: 'Descriere tort aniversare 218',
    image: '/images/birthday-cakes/00218.webp',
    type: 'birthdayCakes',
  },
  {
    id: 397,
    title: 'Tort aniversare 219',
    description: 'Descriere tort aniversare 219',
    image: '/images/birthday-cakes/00219.webp',
    type: 'birthdayCakes',
  },
  {
    id: 398,
    title: 'Tort aniversare 220',
    description: 'Descriere tort aniversare 220',
    image: '/images/birthday-cakes/00220.webp',
    type: 'birthdayCakes',
  },
  {
    id: 399,
    title: 'Tort aniversare 221',
    description: 'Descriere tort aniversare 221',
    image: '/images/birthday-cakes/00221.webp',
    type: 'birthdayCakes',
  },
  {
    id: 400,
    title: 'Tort aniversare 222',
    description: 'Descriere tort aniversare 222',
    image: '/images/birthday-cakes/00222.webp',
    type: 'birthdayCakes',
  },
  {
    id: 401,
    title: 'Tort aniversare 223',
    description: 'Descriere tort aniversare 223',
    image: '/images/birthday-cakes/00223.webp',
    type: 'birthdayCakes',
  },
  {
    id: 402,
    title: 'Tort aniversare 224',
    description: 'Descriere tort aniversare 224',
    image: '/images/birthday-cakes/00224.webp',
    type: 'birthdayCakes',
  },
  {
    id: 403,
    title: 'Tort aniversare 225',
    description: 'Descriere tort aniversare 225',
    image: '/images/birthday-cakes/00225.webp',
    type: 'birthdayCakes',
  },
  {
    id: 404,
    title: 'Tort aniversare 226',
    description: 'Descriere tort aniversare 226',
    image: '/images/birthday-cakes/00226.webp',
    type: 'birthdayCakes',
  },
  {
    id: 405,
    title: 'Tort aniversare 227',
    description: 'Descriere tort aniversare 227',
    image: '/images/birthday-cakes/00227.webp',
    type: 'birthdayCakes',
  },
  {
    id: 406,
    title: 'Tort aniversare 228',
    description: 'Descriere tort aniversare 228',
    image: '/images/birthday-cakes/00228.webp',
    type: 'birthdayCakes',
  },
  {
    id: 407,
    title: 'Tort aniversare 229',
    description: 'Descriere tort aniversare 229',
    image: '/images/birthday-cakes/00229.webp',
    type: 'birthdayCakes',
  },
  {
    id: 408,
    title: 'Tort aniversare 230',
    description: 'Descriere tort aniversare 230',
    image: '/images/birthday-cakes/00230.webp',
    type: 'birthdayCakes',
  },
  {
    id: 409,
    title: 'Tort aniversare 231',
    description: 'Descriere tort aniversare 231',
    image: '/images/birthday-cakes/00231.webp',
    type: 'birthdayCakes',
  },
  {
    id: 410,
    title: 'Tort aniversare 232',
    description: 'Descriere tort aniversare 232',
    image: '/images/birthday-cakes/00232.webp',
    type: 'birthdayCakes',
  },
  {
    id: 411,
    title: 'Tort aniversare 233',
    description: 'Descriere tort aniversare 233',
    image: '/images/birthday-cakes/00233.webp',
    type: 'birthdayCakes',
  },
  {
    id: 412,
    title: 'Tort aniversare 234',
    description: 'Descriere tort aniversare 234',
    image: '/images/birthday-cakes/00234.webp',
    type: 'birthdayCakes',
  },
  {
    id: 413,
    title: 'Tort aniversare 235',
    description: 'Descriere tort aniversare 235',
    image: '/images/birthday-cakes/00235.webp',
    type: 'birthdayCakes',
  },
  {
    id: 414,
    title: 'Tort aniversare 236',
    description: 'Descriere tort aniversare 236',
    image: '/images/birthday-cakes/00236.webp',
    type: 'birthdayCakes',
  },
  {
    id: 415,
    title: 'Tort aniversare 237',
    description: 'Descriere tort aniversare 237',
    image: '/images/birthday-cakes/00237.webp',
    type: 'birthdayCakes',
  },
  {
    id: 416,
    title: 'Tort aniversare 238',
    description: 'Descriere tort aniversare 238',
    image: '/images/birthday-cakes/00238.webp',
    type: 'birthdayCakes',
  },
  {
    id: 417,
    title: 'Tort aniversare 239',
    description: 'Descriere tort aniversare 239',
    image: '/images/birthday-cakes/00239.webp',
    type: 'birthdayCakes',
  },
  {
    id: 418,
    title: 'Tort aniversare 240',
    description: 'Descriere tort aniversare 240',
    image: '/images/birthday-cakes/00240.webp',
    type: 'birthdayCakes',
  },
  {
    id: 419,
    title: 'Tort aniversare 241',
    description: 'Descriere tort aniversare 241',
    image: '/images/birthday-cakes/00241.webp',
    type: 'birthdayCakes',
  },
  {
    id: 420,
    title: 'Tort aniversare 242',
    description: 'Descriere tort aniversare 242',
    image: '/images/birthday-cakes/00242.webp',
    type: 'birthdayCakes',
  },
  {
    id: 421,
    title: 'Tort aniversare 243',
    description: 'Descriere tort aniversare 243',
    image: '/images/birthday-cakes/00243.webp',
    type: 'birthdayCakes',
  },
  {
    id: 422,
    title: 'Tort aniversare 244',
    description: 'Descriere tort aniversare 244',
    image: '/images/birthday-cakes/00244.webp',
    type: 'birthdayCakes',
  },
  {
    id: 423,
    title: 'Tort aniversare 245',
    description: 'Descriere tort aniversare 245',
    image: '/images/birthday-cakes/00245.webp',
    type: 'birthdayCakes',
  },
  {
    id: 424,
    title: 'Tort aniversare 246',
    description: 'Descriere tort aniversare 246',
    image: '/images/birthday-cakes/00246.webp',
    type: 'birthdayCakes',
  },
  {
    id: 425,
    title: 'Tort aniversare 247',
    description: 'Descriere tort aniversare 247',
    image: '/images/birthday-cakes/00247.webp',
    type: 'birthdayCakes',
  },
  {
    id: 426,
    title: 'Tort aniversare 248',
    description: 'Descriere tort aniversare 248',
    image: '/images/birthday-cakes/00248.webp',
    type: 'birthdayCakes',
  },
  {
    id: 427,
    title: 'Tort aniversare 249',
    description: 'Descriere tort aniversare 249',
    image: '/images/birthday-cakes/00249.webp',
    type: 'birthdayCakes',
  },
  {
    id: 428,
    title: 'Tort aniversare 250',
    description: 'Descriere tort aniversare 250',
    image: '/images/birthday-cakes/00250.webp',
    type: 'birthdayCakes',
  },
  {
    id: 429,
    title: 'Tort aniversare 251',
    description: 'Descriere tort aniversare 251',
    image: '/images/birthday-cakes/00251.webp',
    type: 'birthdayCakes',
  },
  {
    id: 430,
    title: 'Tort aniversare 252',
    description: 'Descriere tort aniversare 252',
    image: '/images/birthday-cakes/00252.webp',
    type: 'birthdayCakes',
  },
  {
    id: 431,
    title: 'Tort aniversare 253',
    description: 'Descriere tort aniversare 253',
    image: '/images/birthday-cakes/00253.webp',
    type: 'birthdayCakes',
  },
  {
    id: 432,
    title: 'Tort aniversare 254',
    description: 'Descriere tort aniversare 254',
    image: '/images/birthday-cakes/00254.webp',
    type: 'birthdayCakes',
  },
  {
    id: 433,
    title: 'Tort aniversare 255',
    description: 'Descriere tort aniversare 255',
    image: '/images/birthday-cakes/00255.webp',
    type: 'birthdayCakes',
  },
  {
    id: 434,
    title: 'Tort aniversare 256',
    description: 'Descriere tort aniversare 256',
    image: '/images/birthday-cakes/00256.webp',
    type: 'birthdayCakes',
  },
  {
    id: 435,
    title: 'Tort aniversare 257',
    description: 'Descriere tort aniversare 257',
    image: '/images/birthday-cakes/00257.webp',
    type: 'birthdayCakes',
  },
  {
    id: 436,
    title: 'Tort aniversare 258',
    description: 'Descriere tort aniversare 258',
    image: '/images/birthday-cakes/00258.webp',
    type: 'birthdayCakes',
  },
  {
    id: 437,
    title: 'Tort aniversare 259',
    description: 'Descriere tort aniversare 259',
    image: '/images/birthday-cakes/00259.webp',
    type: 'birthdayCakes',
  },
  {
    id: 438,
    title: 'Tort aniversare 260',
    description: 'Descriere tort aniversare 260',
    image: '/images/birthday-cakes/00260.webp',
    type: 'birthdayCakes',
  },
  {
    id: 439,
    title: 'Tort aniversare 261',
    description: 'Descriere tort aniversare 261',
    image: '/images/birthday-cakes/00261.webp',
    type: 'birthdayCakes',
  },
  {
    id: 440,
    title: 'Tort aniversare 262',
    description: 'Descriere tort aniversare 262',
    image: '/images/birthday-cakes/00262.webp',
    type: 'birthdayCakes',
  },
  {
    id: 441,
    title: 'Tort aniversare 263',
    description: 'Descriere tort aniversare 263',
    image: '/images/birthday-cakes/00263.webp',
    type: 'birthdayCakes',
  },
  {
    id: 442,
    title: 'Tort aniversare 264',
    description: 'Descriere tort aniversare 264',
    image: '/images/birthday-cakes/00264.webp',
    type: 'birthdayCakes',
  },
  {
    id: 443,
    title: 'Tort aniversare 265',
    description: 'Descriere tort aniversare 265',
    image: '/images/birthday-cakes/00265.webp',
    type: 'birthdayCakes',
  },
  {
    id: 444,
    title: 'Tort aniversare 266',
    description: 'Descriere tort aniversare 266',
    image: '/images/birthday-cakes/00266.webp',
    type: 'birthdayCakes',
  },
  {
    id: 445,
    title: 'Tort aniversare 267',
    description: 'Descriere tort aniversare 267',
    image: '/images/birthday-cakes/00267.webp',
    type: 'birthdayCakes',
  },
  {
    id: 446,
    title: 'Tort aniversare 268',
    description: 'Descriere tort aniversare 268',
    image: '/images/birthday-cakes/00268.webp',
    type: 'birthdayCakes',
  },
  {
    id: 447,
    title: 'Tort aniversare 269',
    description: 'Descriere tort aniversare 269',
    image: '/images/birthday-cakes/00269.webp',
    type: 'birthdayCakes',
  },
  {
    id: 448,
    title: 'Tort aniversare 270',
    description: 'Descriere tort aniversare 270',
    image: '/images/birthday-cakes/00270.webp',
    type: 'birthdayCakes',
  },
  {
    id: 449,
    title: 'Tort aniversare 271',
    description: 'Descriere tort aniversare 271',
    image: '/images/birthday-cakes/00271.webp',
    type: 'birthdayCakes',
  },
  {
    id: 450,
    title: 'Tort aniversare 272',
    description: 'Descriere tort aniversare 272',
    image: '/images/birthday-cakes/00272.webp',
    type: 'birthdayCakes',
  },
  {
    id: 451,
    title: 'Tort aniversare 273',
    description: 'Descriere tort aniversare 273',
    image: '/images/birthday-cakes/00273.webp',
    type: 'birthdayCakes',
  },
  {
    id: 452,
    title: 'Tort aniversare 274',
    description: 'Descriere tort aniversare 274',
    image: '/images/birthday-cakes/00274.webp',
    type: 'birthdayCakes',
  },
  {
    id: 453,
    title: 'Tort aniversare 275',
    description: 'Descriere tort aniversare 275',
    image: '/images/birthday-cakes/00275.webp',
    type: 'birthdayCakes',
  },
  {
    id: 454,
    title: 'Tort aniversare 276',
    description: 'Descriere tort aniversare 276',
    image: '/images/birthday-cakes/00276.webp',
    type: 'birthdayCakes',
  },
  {
    id: 455,
    title: 'Tort aniversare 277',
    description: 'Descriere tort aniversare 277',
    image: '/images/birthday-cakes/00277.webp',
    type: 'birthdayCakes',
  },
  {
    id: 456,
    title: 'Tort aniversare 278',
    description: 'Descriere tort aniversare 278',
    image: '/images/birthday-cakes/00278.webp',
    type: 'birthdayCakes',
  },
  {
    id: 457,
    title: 'Tort aniversare 279',
    description: 'Descriere tort aniversare 279',
    image: '/images/birthday-cakes/00279.webp',
    type: 'birthdayCakes',
  },
  {
    id: 458,
    title: 'Tort aniversare 280',
    description: 'Descriere tort aniversare 280',
    image: '/images/birthday-cakes/00280.webp',
    type: 'birthdayCakes',
  },
  {
    id: 459,
    title: 'Tort aniversare 281',
    description: 'Descriere tort aniversare 281',
    image: '/images/birthday-cakes/00281.webp',
    type: 'birthdayCakes',
  },
  {
    id: 460,
    title: 'Tort aniversare 282',
    description: 'Descriere tort aniversare 282',
    image: '/images/birthday-cakes/00282.webp',
    type: 'birthdayCakes',
  },
  {
    id: 461,
    title: 'Tort aniversare 283',
    description: 'Descriere tort aniversare 283',
    image: '/images/birthday-cakes/00283.webp',
    type: 'birthdayCakes',
  },
  {
    id: 462,
    title: 'Tort aniversare 284',
    description: 'Descriere tort aniversare 284',
    image: '/images/birthday-cakes/00284.webp',
    type: 'birthdayCakes',
  },
  {
    id: 463,
    title: 'Tort aniversare 285',
    description: 'Descriere tort aniversare 285',
    image: '/images/birthday-cakes/00285.webp',
    type: 'birthdayCakes',
  },
  {
    id: 464,
    title: 'Tort aniversare 286',
    description: 'Descriere tort aniversare 286',
    image: '/images/birthday-cakes/00286.webp',
    type: 'birthdayCakes',
  },
  {
    id: 465,
    title: 'Tort aniversare 287',
    description: 'Descriere tort aniversare 287',
    image: '/images/birthday-cakes/00287.webp',
    type: 'birthdayCakes',
  },
  {
    id: 466,
    title: 'Tort aniversare 288',
    description: 'Descriere tort aniversare 288',
    image: '/images/birthday-cakes/00288.webp',
    type: 'birthdayCakes',
  },
  {
    id: 467,
    title: 'Tort aniversare 289',
    description: 'Descriere tort aniversare 289',
    image: '/images/birthday-cakes/00289.webp',
    type: 'birthdayCakes',
  },
  {
    id: 468,
    title: 'Tort aniversare 290',
    description: 'Descriere tort aniversare 290',
    image: '/images/birthday-cakes/00290.webp',
    type: 'birthdayCakes',
  },
  {
    id: 469,
    title: 'Tort aniversare 291',
    description: 'Descriere tort aniversare 291',
    image: '/images/birthday-cakes/00291.webp',
    type: 'birthdayCakes',
  },
  {
    id: 470,
    title: 'Tort aniversare 292',
    description: 'Descriere tort aniversare 292',
    image: '/images/birthday-cakes/00292.webp',
    type: 'birthdayCakes',
  },
  {
    id: 471,
    title: 'Tort aniversare 293',
    description: 'Descriere tort aniversare 293',
    image: '/images/birthday-cakes/00293.webp',
    type: 'birthdayCakes',
  },
  {
    id: 472,
    title: 'Tort aniversare 294',
    description: 'Descriere tort aniversare 294',
    image: '/images/birthday-cakes/00294.webp',
    type: 'birthdayCakes',
  },
  {
    id: 473,
    title: 'Tort aniversare 295',
    description: 'Descriere tort aniversare 295',
    image: '/images/birthday-cakes/00295.webp',
    type: 'birthdayCakes',
  },
  {
    id: 474,
    title: 'Tort aniversare 296',
    description: 'Descriere tort aniversare 296',
    image: '/images/birthday-cakes/00296.webp',
    type: 'birthdayCakes',
  },
  {
    id: 475,
    title: 'Tort aniversare 297',
    description: 'Descriere tort aniversare 297',
    image: '/images/birthday-cakes/00297.webp',
    type: 'birthdayCakes',
  },
  {
    id: 476,
    title: 'Tort aniversare 298',
    description: 'Descriere tort aniversare 298',
    image: '/images/birthday-cakes/00298.webp',
    type: 'birthdayCakes',
  },
  {
    id: 477,
    title: 'Tort aniversare 299',
    description: 'Descriere tort aniversare 299',
    image: '/images/birthday-cakes/00299.webp',
    type: 'birthdayCakes',
  },
  {
    id: 478,
    title: 'Tort aniversare 300',
    description: 'Descriere tort aniversare 300',
    image: '/images/birthday-cakes/00300.webp',
    type: 'birthdayCakes',
  },
  {
    id: 479,
    title: 'Tort aniversare 301',
    description: 'Descriere tort aniversare 301',
    image: '/images/birthday-cakes/00301.webp',
    type: 'birthdayCakes',
  },
  {
    id: 480,
    title: 'Tort aniversare 302',
    description: 'Descriere tort aniversare 302',
    image: '/images/birthday-cakes/00302.webp',
    type: 'birthdayCakes',
  },
  {
    id: 481,
    title: 'Tort aniversare 303',
    description: 'Descriere tort aniversare 303',
    image: '/images/birthday-cakes/00303.webp',
    type: 'birthdayCakes',
  },
  {
    id: 482,
    title: 'Tort aniversare 304',
    description: 'Descriere tort aniversare 304',
    image: '/images/birthday-cakes/00304.webp',
    type: 'birthdayCakes',
  },
  {
    id: 483,
    title: 'Tort aniversare 305',
    description: 'Descriere tort aniversare 305',
    image: '/images/birthday-cakes/00305.webp',
    type: 'birthdayCakes',
  },
  {
    id: 484,
    title: 'Tort aniversare 306',
    description: 'Descriere tort aniversare 306',
    image: '/images/birthday-cakes/00306.webp',
    type: 'birthdayCakes',
  },
  {
    id: 485,
    title: 'Tort aniversare 307',
    description: 'Descriere tort aniversare 307',
    image: '/images/birthday-cakes/00307.webp',
    type: 'birthdayCakes',
  },
  {
    id: 486,
    title: 'Tort aniversare 308',
    description: 'Descriere tort aniversare 308',
    image: '/images/birthday-cakes/00308.webp',
    type: 'birthdayCakes',
  },
  {
    id: 487,
    title: 'Tort aniversare 309',
    description: 'Descriere tort aniversare 309',
    image: '/images/birthday-cakes/00309.webp',
    type: 'birthdayCakes',
  },
  {
    id: 488,
    title: 'Tort aniversare 310',
    description: 'Descriere tort aniversare 310',
    image: '/images/birthday-cakes/00310.webp',
    type: 'birthdayCakes',
  },
  {
    id: 489,
    title: 'Tort aniversare 311',
    description: 'Descriere tort aniversare 311',
    image: '/images/birthday-cakes/00311.webp',
    type: 'birthdayCakes',
  },
  {
    id: 490,
    title: 'Tort aniversare 312',
    description: 'Descriere tort aniversare 312',
    image: '/images/birthday-cakes/00312.webp',
    type: 'birthdayCakes',
  },
  {
    id: 491,
    title: 'Tort aniversare 313',
    description: 'Descriere tort aniversare 313',
    image: '/images/birthday-cakes/00313.webp',
    type: 'birthdayCakes',
  },
  {
    id: 492,
    title: 'Tort aniversare 314',
    description: 'Descriere tort aniversare 314',
    image: '/images/birthday-cakes/00314.webp',
    type: 'birthdayCakes',
  },
  {
    id: 493,
    title: 'Tort aniversare 315',
    description: 'Descriere tort aniversare 315',
    image: '/images/birthday-cakes/00315.webp',
    type: 'birthdayCakes',
  },
  {
    id: 494,
    title: 'Tort aniversare 316',
    description: 'Descriere tort aniversare 316',
    image: '/images/birthday-cakes/00316.webp',
    type: 'birthdayCakes',
  },
  {
    id: 495,
    title: 'Tort aniversare 317',
    description: 'Descriere tort aniversare 317',
    image: '/images/birthday-cakes/00317.webp',
    type: 'birthdayCakes',
  },
  {
    id: 496,
    title: 'Tort aniversare 318',
    description: 'Descriere tort aniversare 318',
    image: '/images/birthday-cakes/00318.webp',
    type: 'birthdayCakes',
  },
  {
    id: 497,
    title: 'Tort aniversare 319',
    description: 'Descriere tort aniversare 319',
    image: '/images/birthday-cakes/00319.webp',
    type: 'birthdayCakes',
  },
  {
    id: 498,
    title: 'Tort aniversare 320',
    description: 'Descriere tort aniversare 320',
    image: '/images/birthday-cakes/00320.webp',
    type: 'birthdayCakes',
  },
  {
    id: 499,
    title: 'Tort aniversare 321',
    description: 'Descriere tort aniversare 321',
    image: '/images/birthday-cakes/00321.webp',
    type: 'birthdayCakes',
  },
  {
    id: 500,
    title: 'Tort aniversare 322',
    description: 'Descriere tort aniversare 322',
    image: '/images/birthday-cakes/00322.webp',
    type: 'birthdayCakes',
  },
  {
    id: 501,
    title: 'Tort aniversare 323',
    description: 'Descriere tort aniversare 323',
    image: '/images/birthday-cakes/00323.webp',
    type: 'birthdayCakes',
  },
  {
    id: 502,
    title: 'Tort aniversare 324',
    description: 'Descriere tort aniversare 324',
    image: '/images/birthday-cakes/00324.webp',
    type: 'birthdayCakes',
  },
  {
    id: 503,
    title: 'Tort aniversare 325',
    description: 'Descriere tort aniversare 325',
    image: '/images/birthday-cakes/00325.webp',
    type: 'birthdayCakes',
  },
  {
    id: 504,
    title: 'Tort aniversare 326',
    description: 'Descriere tort aniversare 326',
    image: '/images/birthday-cakes/00326.webp',
    type: 'birthdayCakes',
  },
  {
    id: 505,
    title: 'Tort aniversare 327',
    description: 'Descriere tort aniversare 327',
    image: '/images/birthday-cakes/00327.webp',
    type: 'birthdayCakes',
  },
  {
    id: 506,
    title: 'Tort aniversare 328',
    description: 'Descriere tort aniversare 328',
    image: '/images/birthday-cakes/00328.webp',
    type: 'birthdayCakes',
  },
  {
    id: 507,
    title: 'Tort aniversare 329',
    description: 'Descriere tort aniversare 329',
    image: '/images/birthday-cakes/00329.webp',
    type: 'birthdayCakes',
  },
  {
    id: 508,
    title: 'Tort aniversare 330',
    description: 'Descriere tort aniversare 330',
    image: '/images/birthday-cakes/00330.webp',
    type: 'birthdayCakes',
  },
  {
    id: 509,
    title: 'Tort aniversare 331',
    description: 'Descriere tort aniversare 331',
    image: '/images/birthday-cakes/00331.webp',
    type: 'birthdayCakes',
  },
  {
    id: 510,
    title: 'Tort aniversare 332',
    description: 'Descriere tort aniversare 332',
    image: '/images/birthday-cakes/00332.webp',
    type: 'birthdayCakes',
  },
  {
    id: 511,
    title: 'Tort aniversare 333',
    description: 'Descriere tort aniversare 333',
    image: '/images/birthday-cakes/00333.webp',
    type: 'birthdayCakes',
  },
  {
    id: 512,
    title: 'Tort aniversare 334',
    description: 'Descriere tort aniversare 334',
    image: '/images/birthday-cakes/00334.webp',
    type: 'birthdayCakes',
  },
  {
    id: 513,
    title: 'Tort aniversare 335',
    description: 'Descriere tort aniversare 335',
    image: '/images/birthday-cakes/00335.webp',
    type: 'birthdayCakes',
  },
  {
    id: 514,
    title: 'Tort aniversare 336',
    description: 'Descriere tort aniversare 336',
    image: '/images/birthday-cakes/00336.webp',
    type: 'birthdayCakes',
  },
  {
    id: 515,
    title: 'Tort aniversare 337',
    description: 'Descriere tort aniversare 337',
    image: '/images/birthday-cakes/00337.webp',
    type: 'birthdayCakes',
  },
  {
    id: 516,
    title: 'Tort aniversare 338',
    description: 'Descriere tort aniversare 338',
    image: '/images/birthday-cakes/00338.webp',
    type: 'birthdayCakes',
  },
  {
    id: 517,
    title: 'Tort aniversare 339',
    description: 'Descriere tort aniversare 339',
    image: '/images/birthday-cakes/00339.webp',
    type: 'birthdayCakes',
  },
  {
    id: 518,
    title: 'Tort aniversare 340',
    description: 'Descriere tort aniversare 340',
    image: '/images/birthday-cakes/00340.webp',
    type: 'birthdayCakes',
  },
  {
    id: 519,
    title: 'Tort aniversare 341',
    description: 'Descriere tort aniversare 341',
    image: '/images/birthday-cakes/00341.webp',
    type: 'birthdayCakes',
  },
  {
    id: 520,
    title: 'Tort aniversare 342',
    description: 'Descriere tort aniversare 342',
    image: '/images/birthday-cakes/00342.webp',
    type: 'birthdayCakes',
  },
  {
    id: 521,
    title: 'Tort aniversare 343',
    description: 'Descriere tort aniversare 343',
    image: '/images/birthday-cakes/00343.webp',
    type: 'birthdayCakes',
  },
  {
    id: 522,
    title: 'Tort aniversare 344',
    description: 'Descriere tort aniversare 344',
    image: '/images/birthday-cakes/00344.webp',
    type: 'birthdayCakes',
  },
  {
    id: 523,
    title: 'Tort aniversare 345',
    description: 'Descriere tort aniversare 345',
    image: '/images/birthday-cakes/00345.webp',
    type: 'birthdayCakes',
  },
  {
    id: 524,
    title: 'Tort aniversare 346',
    description: 'Descriere tort aniversare 346',
    image: '/images/birthday-cakes/00346.webp',
    type: 'birthdayCakes',
  },
  {
    id: 525,
    title: 'Tort aniversare 347',
    description: 'Descriere tort aniversare 347',
    image: '/images/birthday-cakes/00347.webp',
    type: 'birthdayCakes',
  },
  {
    id: 526,
    title: 'Tort aniversare 348',
    description: 'Descriere tort aniversare 348',
    image: '/images/birthday-cakes/00348.webp',
    type: 'birthdayCakes',
  },
  {
    id: 527,
    title: 'Tort aniversare 349',
    description: 'Descriere tort aniversare 349',
    image: '/images/birthday-cakes/00349.webp',
    type: 'birthdayCakes',
  },
  {
    id: 528,
    title: 'Tort aniversare 350',
    description: 'Descriere tort aniversare 350',
    image: '/images/birthday-cakes/00350.webp',
    type: 'birthdayCakes',
  },
  {
    id: 529,
    title: 'Tort aniversare 351',
    description: 'Descriere tort aniversare 351',
    image: '/images/birthday-cakes/00351.webp',
    type: 'birthdayCakes',
  },
  {
    id: 530,
    title: 'Tort aniversare 352',
    description: 'Descriere tort aniversare 352',
    image: '/images/birthday-cakes/00352.webp',
    type: 'birthdayCakes',
  },
  {
    id: 531,
    title: 'Tort aniversare 353',
    description: 'Descriere tort aniversare 353',
    image: '/images/birthday-cakes/00353.webp',
    type: 'birthdayCakes',
  },
  {
    id: 532,
    title: 'Tort aniversare 354',
    description: 'Descriere tort aniversare 354',
    image: '/images/birthday-cakes/00354.webp',
    type: 'birthdayCakes',
  },
  {
    id: 533,
    title: 'Tort aniversare 355',
    description: 'Descriere tort aniversare 355',
    image: '/images/birthday-cakes/00355.webp',
    type: 'birthdayCakes',
  },
  {
    id: 534,
    title: 'Tort aniversare 356',
    description: 'Descriere tort aniversare 356',
    image: '/images/birthday-cakes/00356.webp',
    type: 'birthdayCakes',
  },
  {
    id: 535,
    title: 'Tort aniversare 357',
    description: 'Descriere tort aniversare 357',
    image: '/images/birthday-cakes/00357.webp',
    type: 'birthdayCakes',
  },
  {
    id: 536,
    title: 'Tort aniversare 358',
    description: 'Descriere tort aniversare 358',
    image: '/images/birthday-cakes/00358.webp',
    type: 'birthdayCakes',
  },
  {
    id: 537,
    title: 'Tort aniversare 359',
    description: 'Descriere tort aniversare 359',
    image: '/images/birthday-cakes/00359.webp',
    type: 'birthdayCakes',
  },
  {
    id: 538,
    title: 'Tort aniversare 360',
    description: 'Descriere tort aniversare 360',
    image: '/images/birthday-cakes/00360.webp',
    type: 'birthdayCakes',
  },
  {
    id: 539,
    title: 'Tort aniversare 361',
    description: 'Descriere tort aniversare 361',
    image: '/images/birthday-cakes/00361.webp',
    type: 'birthdayCakes',
  },
  {
    id: 540,
    title: 'Tort aniversare 362',
    description: 'Descriere tort aniversare 362',
    image: '/images/birthday-cakes/00362.webp',
    type: 'birthdayCakes',
  },
  {
    id: 541,
    title: 'Tort aniversare 363',
    description: 'Descriere tort aniversare 363',
    image: '/images/birthday-cakes/00363.webp',
    type: 'birthdayCakes',
  },
  {
    id: 542,
    title: 'Tort aniversare 364',
    description: 'Descriere tort aniversare 364',
    image: '/images/birthday-cakes/00364.webp',
    type: 'birthdayCakes',
  },
  {
    id: 543,
    title: 'Tort aniversare 365',
    description: 'Descriere tort aniversare 365',
    image: '/images/birthday-cakes/00365.webp',
    type: 'birthdayCakes',
  },
  {
    id: 544,
    title: 'Tort aniversare 366',
    description: 'Descriere tort aniversare 366',
    image: '/images/birthday-cakes/00366.webp',
    type: 'birthdayCakes',
  },
  {
    id: 545,
    title: 'Tort aniversare 367',
    description: 'Descriere tort aniversare 367',
    image: '/images/birthday-cakes/00367.webp',
    type: 'birthdayCakes',
  },
  {
    id: 546,
    title: 'Tort aniversare 368',
    description: 'Descriere tort aniversare 368',
    image: '/images/birthday-cakes/00368.webp',
    type: 'birthdayCakes',
  },
  {
    id: 547,
    title: 'Tort aniversare 369',
    description: 'Descriere tort aniversare 369',
    image: '/images/birthday-cakes/00369.webp',
    type: 'birthdayCakes',
  },
  {
    id: 548,
    title: 'Tort aniversare 370',
    description: 'Descriere tort aniversare 370',
    image: '/images/birthday-cakes/00370.webp',
    type: 'birthdayCakes',
  },
  {
    id: 549,
    title: 'Tort aniversare 371',
    description: 'Descriere tort aniversare 371',
    image: '/images/birthday-cakes/00371.webp',
    type: 'birthdayCakes',
  },
  {
    id: 550,
    title: 'Tort aniversare 372',
    description: 'Descriere tort aniversare 372',
    image: '/images/birthday-cakes/00372.webp',
    type: 'birthdayCakes',
  },
  {
    id: 551,
    title: 'Tort aniversare 373',
    description: 'Descriere tort aniversare 373',
    image: '/images/birthday-cakes/00373.webp',
    type: 'birthdayCakes',
  },
  {
    id: 552,
    title: 'Tort aniversare 374',
    description: 'Descriere tort aniversare 374',
    image: '/images/birthday-cakes/00374.webp',
    type: 'birthdayCakes',
  },
  {
    id: 553,
    title: 'Tort aniversare 375',
    description: 'Descriere tort aniversare 375',
    image: '/images/birthday-cakes/00375.webp',
    type: 'birthdayCakes',
  },
  {
    id: 554,
    title: 'Tort aniversare 376',
    description: 'Descriere tort aniversare 376',
    image: '/images/birthday-cakes/00376.webp',
    type: 'birthdayCakes',
  },
  {
    id: 555,
    title: 'Tort aniversare 377',
    description: 'Descriere tort aniversare 377',
    image: '/images/birthday-cakes/00377.webp',
    type: 'birthdayCakes',
  },
  {
    id: 556,
    title: 'Tort aniversare 378',
    description: 'Descriere tort aniversare 378',
    image: '/images/birthday-cakes/00378.webp',
    type: 'birthdayCakes',
  },
  {
    id: 557,
    title: 'Tort aniversare 379',
    description: 'Descriere tort aniversare 379',
    image: '/images/birthday-cakes/00379.webp',
    type: 'birthdayCakes',
  },
  {
    id: 558,
    title: 'Tort aniversare 380',
    description: 'Descriere tort aniversare 380',
    image: '/images/birthday-cakes/00380.webp',
    type: 'birthdayCakes',
  },
  {
    id: 559,
    title: 'Tort aniversare 381',
    description: 'Descriere tort aniversare 381',
    image: '/images/birthday-cakes/00381.webp',
    type: 'birthdayCakes',
  },
  {
    id: 560,
    title: 'Tort aniversare 382',
    description: 'Descriere tort aniversare 382',
    image: '/images/birthday-cakes/00382.webp',
    type: 'birthdayCakes',
  },
  {
    id: 561,
    title: 'Tort aniversare 383',
    description: 'Descriere tort aniversare 383',
    image: '/images/birthday-cakes/00383.webp',
    type: 'birthdayCakes',
  },
  {
    id: 562,
    title: 'Tort aniversare 384',
    description: 'Descriere tort aniversare 384',
    image: '/images/birthday-cakes/00384.webp',
    type: 'birthdayCakes',
  },
  {
    id: 563,
    title: 'Tort aniversare 385',
    description: 'Descriere tort aniversare 385',
    image: '/images/birthday-cakes/00385.webp',
    type: 'birthdayCakes',
  },
  {
    id: 564,
    title: 'Tort aniversare 386',
    description: 'Descriere tort aniversare 386',
    image: '/images/birthday-cakes/00386.webp',
    type: 'birthdayCakes',
  },
  {
    id: 565,
    title: 'Tort aniversare 387',
    description: 'Descriere tort aniversare 387',
    image: '/images/birthday-cakes/00387.webp',
    type: 'birthdayCakes',
  },
  {
    id: 566,
    title: 'Tort aniversare 388',
    description: 'Descriere tort aniversare 388',
    image: '/images/birthday-cakes/00388.webp',
    type: 'birthdayCakes',
  },
  {
    id: 567,
    title: 'Tort aniversare 389',
    description: 'Descriere tort aniversare 389',
    image: '/images/birthday-cakes/00389.webp',
    type: 'birthdayCakes',
  },
  {
    id: 568,
    title: 'Tort aniversare 390',
    description: 'Descriere tort aniversare 390',
    image: '/images/birthday-cakes/00390.webp',
    type: 'birthdayCakes',
  },
  {
    id: 569,
    title: 'Tort aniversare 391',
    description: 'Descriere tort aniversare 391',
    image: '/images/birthday-cakes/00391.webp',
    type: 'birthdayCakes',
  },
  {
    id: 570,
    title: 'Tort aniversare 392',
    description: 'Descriere tort aniversare 392',
    image: '/images/birthday-cakes/00392.webp',
    type: 'birthdayCakes',
  },
  {
    id: 571,
    title: 'Tort aniversare 393',
    description: 'Descriere tort aniversare 393',
    image: '/images/birthday-cakes/00393.webp',
    type: 'birthdayCakes',
  },
  {
    id: 572,
    title: 'Tort aniversare 394',
    description: 'Descriere tort aniversare 394',
    image: '/images/birthday-cakes/00394.webp',
    type: 'birthdayCakes',
  },
  {
    id: 573,
    title: 'Tort aniversare 395',
    description: 'Descriere tort aniversare 395',
    image: '/images/birthday-cakes/00395.webp',
    type: 'birthdayCakes',
  },
  {
    id: 574,
    title: 'Tort aniversare 396',
    description: 'Descriere tort aniversare 396',
    image: '/images/birthday-cakes/00396.webp',
    type: 'birthdayCakes',
  },
  {
    id: 575,
    title: 'Tort aniversare 397',
    description: 'Descriere tort aniversare 397',
    image: '/images/birthday-cakes/00397.webp',
    type: 'birthdayCakes',
  },
  {
    id: 576,
    title: 'Tort aniversare 398',
    description: 'Descriere tort aniversare 398',
    image: '/images/birthday-cakes/00398.webp',
    type: 'birthdayCakes',
  },
  {
    id: 577,
    title: 'Tort aniversare 399',
    description: 'Descriere tort aniversare 399',
    image: '/images/birthday-cakes/00399.webp',
    type: 'birthdayCakes',
  },
  {
    id: 578,
    title: 'Tort aniversare 400',
    description: 'Descriere tort aniversare 400',
    image: '/images/birthday-cakes/00400.webp',
    type: 'birthdayCakes',
  },
  {
    id: 579,
    title: 'Tort aniversare 401',
    description: 'Descriere tort aniversare 401',
    image: '/images/birthday-cakes/00401.webp',
    type: 'birthdayCakes',
  },
  {
    id: 580,
    title: 'Tort aniversare 402',
    description: 'Descriere tort aniversare 402',
    image: '/images/birthday-cakes/00402.webp',
    type: 'birthdayCakes',
  },
  {
    id: 581,
    title: 'Tort aniversare 403',
    description: 'Descriere tort aniversare 403',
    image: '/images/birthday-cakes/00403.webp',
    type: 'birthdayCakes',
  },
  {
    id: 582,
    title: 'Tort aniversare 404',
    description: 'Descriere tort aniversare 404',
    image: '/images/birthday-cakes/00404.webp',
    type: 'birthdayCakes',
  },
  {
    id: 583,
    title: 'Tort aniversare 405',
    description: 'Descriere tort aniversare 405',
    image: '/images/birthday-cakes/00405.webp',
    type: 'birthdayCakes',
  },
  {
    id: 584,
    title: 'Tort aniversare 406',
    description: 'Descriere tort aniversare 406',
    image: '/images/birthday-cakes/00406.webp',
    type: 'birthdayCakes',
  },
  {
    id: 585,
    title: 'Tort aniversare 407',
    description: 'Descriere tort aniversare 407',
    image: '/images/birthday-cakes/00407.webp',
    type: 'birthdayCakes',
  },
  {
    id: 586,
    title: 'Tort aniversare 408',
    description: 'Descriere tort aniversare 408',
    image: '/images/birthday-cakes/00408.webp',
    type: 'birthdayCakes',
  },
  {
    id: 587,
    title: 'Tort aniversare 409',
    description: 'Descriere tort aniversare 409',
    image: '/images/birthday-cakes/00409.webp',
    type: 'birthdayCakes',
  },
  {
    id: 588,
    title: 'Tort aniversare 410',
    description: 'Descriere tort aniversare 410',
    image: '/images/birthday-cakes/00410.webp',
    type: 'birthdayCakes',
  },
  {
    id: 589,
    title: 'Tort aniversare 411',
    description: 'Descriere tort aniversare 411',
    image: '/images/birthday-cakes/00411.webp',
    type: 'birthdayCakes',
  },
  {
    id: 590,
    title: 'Tort aniversare 412',
    description: 'Descriere tort aniversare 412',
    image: '/images/birthday-cakes/00412.webp',
    type: 'birthdayCakes',
  },
  {
    id: 591,
    title: 'Tort aniversare 413',
    description: 'Descriere tort aniversare 413',
    image: '/images/birthday-cakes/00413.webp',
    type: 'birthdayCakes',
  },
  {
    id: 592,
    title: 'Tort aniversare 414',
    description: 'Descriere tort aniversare 414',
    image: '/images/birthday-cakes/00414.webp',
    type: 'birthdayCakes',
  },
  {
    id: 593,
    title: 'Tort aniversare 415',
    description: 'Descriere tort aniversare 415',
    image: '/images/birthday-cakes/00415.webp',
    type: 'birthdayCakes',
  },
  {
    id: 594,
    title: 'Tort aniversare 416',
    description: 'Descriere tort aniversare 416',
    image: '/images/birthday-cakes/00416.webp',
    type: 'birthdayCakes',
  },
  {
    id: 595,
    title: 'Tort aniversare 417',
    description: 'Descriere tort aniversare 417',
    image: '/images/birthday-cakes/00417.webp',
    type: 'birthdayCakes',
  },
  {
    id: 596,
    title: 'Tort aniversare 418',
    description: 'Descriere tort aniversare 418',
    image: '/images/birthday-cakes/00418.webp',
    type: 'birthdayCakes',
  },
  {
    id: 597,
    title: 'Tort aniversare 419',
    description: 'Descriere tort aniversare 419',
    image: '/images/birthday-cakes/00419.webp',
    type: 'birthdayCakes',
  },
  {
    id: 598,
    title: 'Tort aniversare 420',
    description: 'Descriere tort aniversare 420',
    image: '/images/birthday-cakes/00420.webp',
    type: 'birthdayCakes',
  },
  {
    id: 599,
    title: 'Tort aniversare 421',
    description: 'Descriere tort aniversare 421',
    image: '/images/birthday-cakes/00421.webp',
    type: 'birthdayCakes',
  },
  {
    id: 600,
    title: 'Tort aniversare 422',
    description: 'Descriere tort aniversare 422',
    image: '/images/birthday-cakes/00422.webp',
    type: 'birthdayCakes',
  },
  {
    id: 601,
    title: 'Tort aniversare 423',
    description: 'Descriere tort aniversare 423',
    image: '/images/birthday-cakes/00423.webp',
    type: 'birthdayCakes',
  },
  {
    id: 602,
    title: 'Tort aniversare 424',
    description: 'Descriere tort aniversare 424',
    image: '/images/birthday-cakes/00424.webp',
    type: 'birthdayCakes',
  },
  {
    id: 603,
    title: 'Tort aniversare 425',
    description: 'Descriere tort aniversare 425',
    image: '/images/birthday-cakes/00425.webp',
    type: 'birthdayCakes',
  },
  {
    id: 604,
    title: 'Tort aniversare 426',
    description: 'Descriere tort aniversare 426',
    image: '/images/birthday-cakes/00426.webp',
    type: 'birthdayCakes',
  },
  {
    id: 605,
    title: 'Tort aniversare 427',
    description: 'Descriere tort aniversare 427',
    image: '/images/birthday-cakes/00427.webp',
    type: 'birthdayCakes',
  },
  {
    id: 606,
    title: 'Tort aniversare 428',
    description: 'Descriere tort aniversare 428',
    image: '/images/birthday-cakes/00428.webp',
    type: 'birthdayCakes',
  },
  {
    id: 607,
    title: 'Tort aniversare 429',
    description: 'Descriere tort aniversare 429',
    image: '/images/birthday-cakes/00429.webp',
    type: 'birthdayCakes',
  },
  {
    id: 608,
    title: 'Tort aniversare 430',
    description: 'Descriere tort aniversare 430',
    image: '/images/birthday-cakes/00430.webp',
    type: 'birthdayCakes',
  },
  {
    id: 609,
    title: 'Tort aniversare 431',
    description: 'Descriere tort aniversare 431',
    image: '/images/birthday-cakes/00431.webp',
    type: 'birthdayCakes',
  },
  {
    id: 610,
    title: 'Tort aniversare 432',
    description: 'Descriere tort aniversare 432',
    image: '/images/birthday-cakes/00432.webp',
    type: 'birthdayCakes',
  },
  {
    id: 611,
    title: 'Tort aniversare 433',
    description: 'Descriere tort aniversare 433',
    image: '/images/birthday-cakes/00433.webp',
    type: 'birthdayCakes',
  },
  {
    id: 612,
    title: 'Tort aniversare 434',
    description: 'Descriere tort aniversare 434',
    image: '/images/birthday-cakes/00434.webp',
    type: 'birthdayCakes',
  },
  {
    id: 613,
    title: 'Tort aniversare 435',
    description: 'Descriere tort aniversare 435',
    image: '/images/birthday-cakes/00435.webp',
    type: 'birthdayCakes',
  },
  {
    id: 614,
    title: 'Tort aniversare 436',
    description: 'Descriere tort aniversare 436',
    image: '/images/birthday-cakes/00436.webp',
    type: 'birthdayCakes',
  },
  {
    id: 615,
    title: 'Tort aniversare 437',
    description: 'Descriere tort aniversare 437',
    image: '/images/birthday-cakes/00437.webp',
    type: 'birthdayCakes',
  },
  {
    id: 616,
    title: 'Tort aniversare 438',
    description: 'Descriere tort aniversare 438',
    image: '/images/birthday-cakes/00438.webp',
    type: 'birthdayCakes',
  },
  {
    id: 617,
    title: 'Tort aniversare 439',
    description: 'Descriere tort aniversare 439',
    image: '/images/birthday-cakes/00439.webp',
    type: 'birthdayCakes',
  },
  {
    id: 618,
    title: 'Tort aniversare 440',
    description: 'Descriere tort aniversare 440',
    image: '/images/birthday-cakes/00440.webp',
    type: 'birthdayCakes',
  },
  {
    id: 619,
    title: 'Tort aniversare 441',
    description: 'Descriere tort aniversare 441',
    image: '/images/birthday-cakes/00441.webp',
    type: 'birthdayCakes',
  },
  {
    id: 620,
    title: 'Tort aniversare 442',
    description: 'Descriere tort aniversare 442',
    image: '/images/birthday-cakes/00442.webp',
    type: 'birthdayCakes',
  },
  {
    id: 621,
    title: 'Tort aniversare 443',
    description: 'Descriere tort aniversare 443',
    image: '/images/birthday-cakes/00443.webp',
    type: 'birthdayCakes',
  },
  {
    id: 622,
    title: 'Tort aniversare 444',
    description: 'Descriere tort aniversare 444',
    image: '/images/birthday-cakes/00444.webp',
    type: 'birthdayCakes',
  },
  {
    id: 623,
    title: 'Tort aniversare 445',
    description: 'Descriere tort aniversare 445',
    image: '/images/birthday-cakes/00445.webp',
    type: 'birthdayCakes',
  },
  {
    id: 624,
    title: 'Tort aniversare 446',
    description: 'Descriere tort aniversare 446',
    image: '/images/birthday-cakes/00446.webp',
    type: 'birthdayCakes',
  },
  {
    id: 625,
    title: 'Tort aniversare 447',
    description: 'Descriere tort aniversare 447',
    image: '/images/birthday-cakes/00447.webp',
    type: 'birthdayCakes',
  },
  {
    id: 626,
    title: 'Tort aniversare 448',
    description: 'Descriere tort aniversare 448',
    image: '/images/birthday-cakes/00448.webp',
    type: 'birthdayCakes',
  },
  {
    id: 627,
    title: 'Tort aniversare 449',
    description: 'Descriere tort aniversare 449',
    image: '/images/birthday-cakes/00449.webp',
    type: 'birthdayCakes',
  },
  {
    id: 628,
    title: 'Tort aniversare 450',
    description: 'Descriere tort aniversare 450',
    image: '/images/birthday-cakes/00450.webp',
    type: 'birthdayCakes',
  },
  {
    id: 629,
    title: 'Tort aniversare 451',
    description: 'Descriere tort aniversare 451',
    image: '/images/birthday-cakes/00451.webp',
    type: 'birthdayCakes',
  },
  {
    id: 630,
    title: 'Tort aniversare 452',
    description: 'Descriere tort aniversare 452',
    image: '/images/birthday-cakes/00452.webp',
    type: 'birthdayCakes',
  },
  {
    id: 631,
    title: 'Tort aniversare 453',
    description: 'Descriere tort aniversare 453',
    image: '/images/birthday-cakes/00453.webp',
    type: 'birthdayCakes',
  },
  {
    id: 632,
    title: 'Tort aniversare 454',
    description: 'Descriere tort aniversare 454',
    image: '/images/birthday-cakes/00454.webp',
    type: 'birthdayCakes',
  },
  {
    id: 633,
    title: 'Tort aniversare 455',
    description: 'Descriere tort aniversare 455',
    image: '/images/birthday-cakes/00455.webp',
    type: 'birthdayCakes',
  },
  {
    id: 634,
    title: 'Tort aniversare 456',
    description: 'Descriere tort aniversare 456',
    image: '/images/birthday-cakes/00456.webp',
    type: 'birthdayCakes',
  },
  {
    id: 635,
    title: 'Tort aniversare 457',
    description: 'Descriere tort aniversare 457',
    image: '/images/birthday-cakes/00457.webp',
    type: 'birthdayCakes',
  },
  {
    id: 636,
    title: 'Tort aniversare 458',
    description: 'Descriere tort aniversare 458',
    image: '/images/birthday-cakes/00458.webp',
    type: 'birthdayCakes',
  },
  {
    id: 637,
    title: 'Tort aniversare 459',
    description: 'Descriere tort aniversare 459',
    image: '/images/birthday-cakes/00459.webp',
    type: 'birthdayCakes',
  },
  {
    id: 638,
    title: 'Tort aniversare 460',
    description: 'Descriere tort aniversare 460',
    image: '/images/birthday-cakes/00460.webp',
    type: 'birthdayCakes',
  },
  {
    id: 639,
    title: 'Tort aniversare 461',
    description: 'Descriere tort aniversare 461',
    image: '/images/birthday-cakes/00461.webp',
    type: 'birthdayCakes',
  },
  {
    id: 640,
    title: 'Tort aniversare 462',
    description: 'Descriere tort aniversare 462',
    image: '/images/birthday-cakes/00462.webp',
    type: 'birthdayCakes',
  },
  {
    id: 641,
    title: 'Tort aniversare 463',
    description: 'Descriere tort aniversare 463',
    image: '/images/birthday-cakes/00463.webp',
    type: 'birthdayCakes',
  },
  {
    id: 642,
    title: 'Tort aniversare 464',
    description: 'Descriere tort aniversare 464',
    image: '/images/birthday-cakes/00464.webp',
    type: 'birthdayCakes',
  },
  {
    id: 643,
    title: 'Tort aniversare 465',
    description: 'Descriere tort aniversare 465',
    image: '/images/birthday-cakes/00465.webp',
    type: 'birthdayCakes',
  },
  {
    id: 644,
    title: 'Tort aniversare 466',
    description: 'Descriere tort aniversare 466',
    image: '/images/birthday-cakes/00466.webp',
    type: 'birthdayCakes',
  },
  {
    id: 645,
    title: 'Tort aniversare 467',
    description: 'Descriere tort aniversare 467',
    image: '/images/birthday-cakes/00467.webp',
    type: 'birthdayCakes',
  },
  {
    id: 646,
    title: 'Tort aniversare 468',
    description: 'Descriere tort aniversare 468',
    image: '/images/birthday-cakes/00468.webp',
    type: 'birthdayCakes',
  },
  {
    id: 647,
    title: 'Tort aniversare 469',
    description: 'Descriere tort aniversare 469',
    image: '/images/birthday-cakes/00469.webp',
    type: 'birthdayCakes',
  },
  {
    id: 648,
    title: 'Tort aniversare 470',
    description: 'Descriere tort aniversare 470',
    image: '/images/birthday-cakes/00470.webp',
    type: 'birthdayCakes',
  },
  {
    id: 649,
    title: 'Tort aniversare 471',
    description: 'Descriere tort aniversare 471',
    image: '/images/birthday-cakes/00471.webp',
    type: 'birthdayCakes',
  },
  {
    id: 650,
    title: 'Tort nuntă 1',
    description: 'Descriere tort nuntă 1',
    image: '/images/wedding-cakes/00001.webp',
    type: 'weddingCakes',
  },
  {
    id: 651,
    title: 'Tort nuntă 2',
    description: 'Descriere tort nuntă 2',
    image: '/images/wedding-cakes/00002.webp',
    type: 'weddingCakes',
  },
  {
    id: 652,
    title: 'Tort nuntă 3',
    description: 'Descriere tort nuntă 3',
    image: '/images/wedding-cakes/00003.webp',
    type: 'weddingCakes',
  },
  {
    id: 653,
    title: 'Tort nuntă 4',
    description: 'Descriere tort nuntă 4',
    image: '/images/wedding-cakes/00004.webp',
    type: 'weddingCakes',
  },
  {
    id: 654,
    title: 'Tort nuntă 5',
    description: 'Descriere tort nuntă 5',
    image: '/images/wedding-cakes/00005.webp',
    type: 'weddingCakes',
  },
  {
    id: 655,
    title: 'Tort nuntă 6',
    description: 'Descriere tort nuntă 6',
    image: '/images/wedding-cakes/00006.webp',
    type: 'weddingCakes',
  },
  {
    id: 656,
    title: 'Tort nuntă 7',
    description: 'Descriere tort nuntă 7',
    image: '/images/wedding-cakes/00007.webp',
    type: 'weddingCakes',
  },
  {
    id: 657,
    title: 'Tort nuntă 8',
    description: 'Descriere tort nuntă 8',
    image: '/images/wedding-cakes/00008.webp',
    type: 'weddingCakes',
  },
  {
    id: 658,
    title: 'Tort nuntă 9',
    description: 'Descriere tort nuntă 9',
    image: '/images/wedding-cakes/00009.webp',
    type: 'weddingCakes',
  },
  {
    id: 659,
    title: 'Tort nuntă 10',
    description: 'Descriere tort nuntă 10',
    image: '/images/wedding-cakes/00010.webp',
    type: 'weddingCakes',
  },
  {
    id: 660,
    title: 'Tort nuntă 11',
    description: 'Descriere tort nuntă 11',
    image: '/images/wedding-cakes/00011.webp',
    type: 'weddingCakes',
  },
  {
    id: 661,
    title: 'Tort nuntă 12',
    description: 'Descriere tort nuntă 12',
    image: '/images/wedding-cakes/00012.webp',
    type: 'weddingCakes',
  },
  {
    id: 662,
    title: 'Tort nuntă 13',
    description: 'Descriere tort nuntă 13',
    image: '/images/wedding-cakes/00013.webp',
    type: 'weddingCakes',
  },
  {
    id: 663,
    title: 'Tort nuntă 14',
    description: 'Descriere tort nuntă 14',
    image: '/images/wedding-cakes/00014.webp',
    type: 'weddingCakes',
  },
  {
    id: 664,
    title: 'Tort nuntă 15',
    description: 'Descriere tort nuntă 15',
    image: '/images/wedding-cakes/00015.webp',
    type: 'weddingCakes',
  },
  {
    id: 665,
    title: 'Tort nuntă 16',
    description: 'Descriere tort nuntă 16',
    image: '/images/wedding-cakes/00016.webp',
    type: 'weddingCakes',
  },
  {
    id: 666,
    title: 'Tort nuntă 17',
    description: 'Descriere tort nuntă 17',
    image: '/images/wedding-cakes/00017.webp',
    type: 'weddingCakes',
  },
  {
    id: 667,
    title: 'Tort nuntă 18',
    description: 'Descriere tort nuntă 18',
    image: '/images/wedding-cakes/00018.webp',
    type: 'weddingCakes',
  },
  {
    id: 668,
    title: 'Tort nuntă 19',
    description: 'Descriere tort nuntă 19',
    image: '/images/wedding-cakes/00019.webp',
    type: 'weddingCakes',
  },
  {
    id: 669,
    title: 'Tort nuntă 20',
    description: 'Descriere tort nuntă 20',
    image: '/images/wedding-cakes/00020.webp',
    type: 'weddingCakes',
  },
  {
    id: 670,
    title: 'Tort nuntă 21',
    description: 'Descriere tort nuntă 21',
    image: '/images/wedding-cakes/00021.webp',
    type: 'weddingCakes',
  },
  {
    id: 671,
    title: 'Tort nuntă 22',
    description: 'Descriere tort nuntă 22',
    image: '/images/wedding-cakes/00022.webp',
    type: 'weddingCakes',
  },
  {
    id: 672,
    title: 'Tort nuntă 23',
    description: 'Descriere tort nuntă 23',
    image: '/images/wedding-cakes/00023.webp',
    type: 'weddingCakes',
  },
  {
    id: 673,
    title: 'Tort nuntă 24',
    description: 'Descriere tort nuntă 24',
    image: '/images/wedding-cakes/00024.webp',
    type: 'weddingCakes',
  },
  {
    id: 674,
    title: 'Tort nuntă 25',
    description: 'Descriere tort nuntă 25',
    image: '/images/wedding-cakes/00025.webp',
    type: 'weddingCakes',
  },
  {
    id: 675,
    title: 'Tort nuntă 26',
    description: 'Descriere tort nuntă 26',
    image: '/images/wedding-cakes/00026.webp',
    type: 'weddingCakes',
  },
  {
    id: 676,
    title: 'Tort nuntă 27',
    description: 'Descriere tort nuntă 27',
    image: '/images/wedding-cakes/00027.webp',
    type: 'weddingCakes',
  },
  {
    id: 677,
    title: 'Tort nuntă 28',
    description: 'Descriere tort nuntă 28',
    image: '/images/wedding-cakes/00028.webp',
    type: 'weddingCakes',
  },
  {
    id: 678,
    title: 'Tort nuntă 29',
    description: 'Descriere tort nuntă 29',
    image: '/images/wedding-cakes/00029.webp',
    type: 'weddingCakes',
  },
  {
    id: 679,
    title: 'Tort nuntă 30',
    description: 'Descriere tort nuntă 30',
    image: '/images/wedding-cakes/00030.webp',
    type: 'weddingCakes',
  },
  {
    id: 680,
    title: 'Tort nuntă 31',
    description: 'Descriere tort nuntă 31',
    image: '/images/wedding-cakes/00031.webp',
    type: 'weddingCakes',
  },
  {
    id: 681,
    title: 'Tort nuntă 32',
    description: 'Descriere tort nuntă 32',
    image: '/images/wedding-cakes/00032.webp',
    type: 'weddingCakes',
  },
  {
    id: 682,
    title: 'Tort nuntă 33',
    description: 'Descriere tort nuntă 33',
    image: '/images/wedding-cakes/00033.webp',
    type: 'weddingCakes',
  },
  {
    id: 683,
    title: 'Tort nuntă 34',
    description: 'Descriere tort nuntă 34',
    image: '/images/wedding-cakes/00034.webp',
    type: 'weddingCakes',
  },
  {
    id: 684,
    title: 'Tort nuntă 35',
    description: 'Descriere tort nuntă 35',
    image: '/images/wedding-cakes/00035.webp',
    type: 'weddingCakes',
  },
  {
    id: 685,
    title: 'Tort nuntă 36',
    description: 'Descriere tort nuntă 36',
    image: '/images/wedding-cakes/00036.webp',
    type: 'weddingCakes',
  },
  {
    id: 686,
    title: 'Tort nuntă 37',
    description: 'Descriere tort nuntă 37',
    image: '/images/wedding-cakes/00037.webp',
    type: 'weddingCakes',
  },
  {
    id: 687,
    title: 'Tort nuntă 38',
    description: 'Descriere tort nuntă 38',
    image: '/images/wedding-cakes/00038.webp',
    type: 'weddingCakes',
  },
  {
    id: 688,
    title: 'Tort nuntă 39',
    description: 'Descriere tort nuntă 39',
    image: '/images/wedding-cakes/00039.webp',
    type: 'weddingCakes',
  },
  {
    id: 689,
    title: 'Tort nuntă 40',
    description: 'Descriere tort nuntă 40',
    image: '/images/wedding-cakes/00040.webp',
    type: 'weddingCakes',
  },
  {
    id: 690,
    title: 'Tort nuntă 41',
    description: 'Descriere tort nuntă 41',
    image: '/images/wedding-cakes/00041.webp',
    type: 'weddingCakes',
  },
  {
    id: 691,
    title: 'Tort nuntă 42',
    description: 'Descriere tort nuntă 42',
    image: '/images/wedding-cakes/00042.webp',
    type: 'weddingCakes',
  },
  {
    id: 692,
    title: 'Tort nuntă 43',
    description: 'Descriere tort nuntă 43',
    image: '/images/wedding-cakes/00043.webp',
    type: 'weddingCakes',
  },
  {
    id: 693,
    title: 'Tort nuntă 44',
    description: 'Descriere tort nuntă 44',
    image: '/images/wedding-cakes/00044.webp',
    type: 'weddingCakes',
  },
  {
    id: 694,
    title: 'Tort nuntă 45',
    description: 'Descriere tort nuntă 45',
    image: '/images/wedding-cakes/00045.webp',
    type: 'weddingCakes',
  },
  {
    id: 695,
    title: 'Tort nuntă 46',
    description: 'Descriere tort nuntă 46',
    image: '/images/wedding-cakes/00046.webp',
    type: 'weddingCakes',
  },
  {
    id: 696,
    title: 'Tort nuntă 47',
    description: 'Descriere tort nuntă 47',
    image: '/images/wedding-cakes/00047.webp',
    type: 'weddingCakes',
  },
  {
    id: 697,
    title: 'Tort nuntă 48',
    description: 'Descriere tort nuntă 48',
    image: '/images/wedding-cakes/00048.webp',
    type: 'weddingCakes',
  },
  {
    id: 698,
    title: 'Tort nuntă 49',
    description: 'Descriere tort nuntă 49',
    image: '/images/wedding-cakes/00049.webp',
    type: 'weddingCakes',
  },
  {
    id: 699,
    title: 'Tort nuntă 50',
    description: 'Descriere tort nuntă 50',
    image: '/images/wedding-cakes/00050.webp',
    type: 'weddingCakes',
  },
  {
    id: 700,
    title: 'Tort nuntă 51',
    description: 'Descriere tort nuntă 51',
    image: '/images/wedding-cakes/00051.webp',
    type: 'weddingCakes',
  },
  {
    id: 701,
    title: 'Tort nuntă 52',
    description: 'Descriere tort nuntă 52',
    image: '/images/wedding-cakes/00052.webp',
    type: 'weddingCakes',
  },
  {
    id: 702,
    title: 'Tort nuntă 53',
    description: 'Descriere tort nuntă 53',
    image: '/images/wedding-cakes/00053.webp',
    type: 'weddingCakes',
  },
  {
    id: 703,
    title: 'Tort nuntă 54',
    description: 'Descriere tort nuntă 54',
    image: '/images/wedding-cakes/00054.webp',
    type: 'weddingCakes',
  },
  {
    id: 704,
    title: 'Tort nuntă 55',
    description: 'Descriere tort nuntă 55',
    image: '/images/wedding-cakes/00055.webp',
    type: 'weddingCakes',
  },
  {
    id: 705,
    title: 'Tort nuntă 56',
    description: 'Descriere tort nuntă 56',
    image: '/images/wedding-cakes/00056.webp',
    type: 'weddingCakes',
  },
  {
    id: 706,
    title: 'Tort nuntă 57',
    description: 'Descriere tort nuntă 57',
    image: '/images/wedding-cakes/00057.webp',
    type: 'weddingCakes',
  },
  {
    id: 707,
    title: 'Tort nuntă 58',
    description: 'Descriere tort nuntă 58',
    image: '/images/wedding-cakes/00058.webp',
    type: 'weddingCakes',
  },
  {
    id: 708,
    title: 'Tort nuntă 59',
    description: 'Descriere tort nuntă 59',
    image: '/images/wedding-cakes/00059.webp',
    type: 'weddingCakes',
  },
  {
    id: 709,
    title: 'Tort nuntă 60',
    description: 'Descriere tort nuntă 60',
    image: '/images/wedding-cakes/00060.webp',
    type: 'weddingCakes',
  },
  {
    id: 710,
    title: 'Tort nuntă 61',
    description: 'Descriere tort nuntă 61',
    image: '/images/wedding-cakes/00061.webp',
    type: 'weddingCakes',
  },
  {
    id: 711,
    title: 'Tort nuntă 62',
    description: 'Descriere tort nuntă 62',
    image: '/images/wedding-cakes/00062.webp',
    type: 'weddingCakes',
  },
  {
    id: 712,
    title: 'Tort nuntă 63',
    description: 'Descriere tort nuntă 63',
    image: '/images/wedding-cakes/00063.webp',
    type: 'weddingCakes',
  },
  {
    id: 713,
    title: 'Tort nuntă 64',
    description: 'Descriere tort nuntă 64',
    image: '/images/wedding-cakes/00064.webp',
    type: 'weddingCakes',
  },
  {
    id: 714,
    title: 'Tort nuntă 65',
    description: 'Descriere tort nuntă 65',
    image: '/images/wedding-cakes/00065.webp',
    type: 'weddingCakes',
  },
  {
    id: 715,
    title: 'Tort nuntă 66',
    description: 'Descriere tort nuntă 66',
    image: '/images/wedding-cakes/00066.webp',
    type: 'weddingCakes',
  },
  {
    id: 716,
    title: 'Tort nuntă 67',
    description: 'Descriere tort nuntă 67',
    image: '/images/wedding-cakes/00067.webp',
    type: 'weddingCakes',
  },
  {
    id: 717,
    title: 'Tort nuntă 68',
    description: 'Descriere tort nuntă 68',
    image: '/images/wedding-cakes/00068.webp',
    type: 'weddingCakes',
  },
  {
    id: 718,
    title: 'Tort nuntă 69',
    description: 'Descriere tort nuntă 69',
    image: '/images/wedding-cakes/00069.webp',
    type: 'weddingCakes',
  },
  {
    id: 719,
    title: 'Tort nuntă 70',
    description: 'Descriere tort nuntă 70',
    image: '/images/wedding-cakes/00070.webp',
    type: 'weddingCakes',
  },
  {
    id: 720,
    title: 'Tort nuntă 71',
    description: 'Descriere tort nuntă 71',
    image: '/images/wedding-cakes/00071.webp',
    type: 'weddingCakes',
  },
  {
    id: 721,
    title: 'Tort nuntă 72',
    description: 'Descriere tort nuntă 72',
    image: '/images/wedding-cakes/00072.webp',
    type: 'weddingCakes',
  },
  {
    id: 722,
    title: 'Tort nuntă 73',
    description: 'Descriere tort nuntă 73',
    image: '/images/wedding-cakes/00073.webp',
    type: 'weddingCakes',
  },
  {
    id: 723,
    title: 'Tort nuntă 74',
    description: 'Descriere tort nuntă 74',
    image: '/images/wedding-cakes/00074.webp',
    type: 'weddingCakes',
  },
  {
    id: 724,
    title: 'Tort nuntă 75',
    description: 'Descriere tort nuntă 75',
    image: '/images/wedding-cakes/00075.webp',
    type: 'weddingCakes',
  },
  {
    id: 725,
    title: 'Tort nuntă 76',
    description: 'Descriere tort nuntă 76',
    image: '/images/wedding-cakes/00076.webp',
    type: 'weddingCakes',
  },
  {
    id: 726,
    title: 'Tort nuntă 77',
    description: 'Descriere tort nuntă 77',
    image: '/images/wedding-cakes/00077.webp',
    type: 'weddingCakes',
  },
  {
    id: 727,
    title: 'Tort nuntă 78',
    description: 'Descriere tort nuntă 78',
    image: '/images/wedding-cakes/00078.webp',
    type: 'weddingCakes',
  },
  {
    id: 728,
    title: 'Tort nuntă 79',
    description: 'Descriere tort nuntă 79',
    image: '/images/wedding-cakes/00079.webp',
    type: 'weddingCakes',
  },
  {
    id: 729,
    title: 'Tort nuntă 80',
    description: 'Descriere tort nuntă 80',
    image: '/images/wedding-cakes/00080.webp',
    type: 'weddingCakes',
  },
  {
    id: 730,
    title: 'Tort nuntă 81',
    description: 'Descriere tort nuntă 81',
    image: '/images/wedding-cakes/00081.webp',
    type: 'weddingCakes',
  },
  {
    id: 731,
    title: 'Tort nuntă 82',
    description: 'Descriere tort nuntă 82',
    image: '/images/wedding-cakes/00082.webp',
    type: 'weddingCakes',
  },
  {
    id: 732,
    title: 'Tort nuntă 83',
    description: 'Descriere tort nuntă 83',
    image: '/images/wedding-cakes/00083.webp',
    type: 'weddingCakes',
  },
  {
    id: 733,
    title: 'Tort nuntă 84',
    description: 'Descriere tort nuntă 84',
    image: '/images/wedding-cakes/00084.webp',
    type: 'weddingCakes',
  },
  {
    id: 734,
    title: 'Tort nuntă 85',
    description: 'Descriere tort nuntă 85',
    image: '/images/wedding-cakes/00085.webp',
    type: 'weddingCakes',
  },
  {
    id: 735,
    title: 'Tort nuntă 86',
    description: 'Descriere tort nuntă 86',
    image: '/images/wedding-cakes/00086.webp',
    type: 'weddingCakes',
  },
  {
    id: 736,
    title: 'Tort nuntă 87',
    description: 'Descriere tort nuntă 87',
    image: '/images/wedding-cakes/00087.webp',
    type: 'weddingCakes',
  },
  {
    id: 737,
    title: 'Tort nuntă 88',
    description: 'Descriere tort nuntă 88',
    image: '/images/wedding-cakes/00088.webp',
    type: 'weddingCakes',
  },
  {
    id: 738,
    title: 'Tort nuntă 89',
    description: 'Descriere tort nuntă 89',
    image: '/images/wedding-cakes/00089.webp',
    type: 'weddingCakes',
  },
  {
    id: 739,
    title: 'Tort nuntă 90',
    description: 'Descriere tort nuntă 90',
    image: '/images/wedding-cakes/00090.webp',
    type: 'weddingCakes',
  },
  {
    id: 740,
    title: 'Tort nuntă 91',
    description: 'Descriere tort nuntă 91',
    image: '/images/wedding-cakes/00091.webp',
    type: 'weddingCakes',
  },
  {
    id: 741,
    title: 'Tort nuntă 92',
    description: 'Descriere tort nuntă 92',
    image: '/images/wedding-cakes/00092.webp',
    type: 'weddingCakes',
  },
  {
    id: 742,
    title: 'Tort nuntă 93',
    description: 'Descriere tort nuntă 93',
    image: '/images/wedding-cakes/00093.webp',
    type: 'weddingCakes',
  },
  {
    id: 743,
    title: 'Tort nuntă 94',
    description: 'Descriere tort nuntă 94',
    image: '/images/wedding-cakes/00094.webp',
    type: 'weddingCakes',
  },
  {
    id: 744,
    title: 'Tort nuntă 95',
    description: 'Descriere tort nuntă 95',
    image: '/images/wedding-cakes/00095.webp',
    type: 'weddingCakes',
  },
  {
    id: 745,
    title: 'Tort nuntă 96',
    description: 'Descriere tort nuntă 96',
    image: '/images/wedding-cakes/00096.webp',
    type: 'weddingCakes',
  },
  {
    id: 746,
    title: 'Tort nuntă 97',
    description: 'Descriere tort nuntă 97',
    image: '/images/wedding-cakes/00097.webp',
    type: 'weddingCakes',
  },
  {
    id: 747,
    title: 'Tort nuntă 98',
    description: 'Descriere tort nuntă 98',
    image: '/images/wedding-cakes/00098.webp',
    type: 'weddingCakes',
  },
  {
    id: 748,
    title: 'Tort nuntă 99',
    description: 'Descriere tort nuntă 99',
    image: '/images/wedding-cakes/00099.webp',
    type: 'weddingCakes',
  },
  {
    id: 749,
    title: 'Tort nuntă 100',
    description: 'Descriere tort nuntă 100',
    image: '/images/wedding-cakes/00100.webp',
    type: 'weddingCakes',
  },
  {
    id: 750,
    title: 'Tort nuntă 101',
    description: 'Descriere tort nuntă 101',
    image: '/images/wedding-cakes/00101.webp',
    type: 'weddingCakes',
  },
  {
    id: 751,
    title: 'Tort nuntă 102',
    description: 'Descriere tort nuntă 102',
    image: '/images/wedding-cakes/00102.webp',
    type: 'weddingCakes',
  },
  {
    id: 752,
    title: 'Tort nuntă 103',
    description: 'Descriere tort nuntă 103',
    image: '/images/wedding-cakes/00103.webp',
    type: 'weddingCakes',
  },
  {
    id: 753,
    title: 'Tort nuntă 104',
    description: 'Descriere tort nuntă 104',
    image: '/images/wedding-cakes/00104.webp',
    type: 'weddingCakes',
  },
  {
    id: 754,
    title: 'Tort nuntă 105',
    description: 'Descriere tort nuntă 105',
    image: '/images/wedding-cakes/00105.webp',
    type: 'weddingCakes',
  },
  {
    id: 755,
    title: 'Tort nuntă 106',
    description: 'Descriere tort nuntă 106',
    image: '/images/wedding-cakes/00106.webp',
    type: 'weddingCakes',
  },
  {
    id: 756,
    title: 'Tort nuntă 107',
    description: 'Descriere tort nuntă 107',
    image: '/images/wedding-cakes/00107.webp',
    type: 'weddingCakes',
  },
  {
    id: 757,
    title: 'Tort nuntă 108',
    description: 'Descriere tort nuntă 108',
    image: '/images/wedding-cakes/00108.webp',
    type: 'weddingCakes',
  },
  {
    id: 758,
    title: 'Tort nuntă 109',
    description: 'Descriere tort nuntă 109',
    image: '/images/wedding-cakes/00109.webp',
    type: 'weddingCakes',
  },
  {
    id: 759,
    title: 'Tort nuntă 110',
    description: 'Descriere tort nuntă 110',
    image: '/images/wedding-cakes/00110.webp',
    type: 'weddingCakes',
  },
  {
    id: 760,
    title: 'Tort nuntă 111',
    description: 'Descriere tort nuntă 111',
    image: '/images/wedding-cakes/00111.webp',
    type: 'weddingCakes',
  },
  {
    id: 761,
    title: 'Tort nuntă 112',
    description: 'Descriere tort nuntă 112',
    image: '/images/wedding-cakes/00112.webp',
    type: 'weddingCakes',
  },
  {
    id: 762,
    title: 'Tort nuntă 113',
    description: 'Descriere tort nuntă 113',
    image: '/images/wedding-cakes/00113.webp',
    type: 'weddingCakes',
  },
  {
    id: 763,
    title: 'Tort nuntă 114',
    description: 'Descriere tort nuntă 114',
    image: '/images/wedding-cakes/00114.webp',
    type: 'weddingCakes',
  },
  {
    id: 764,
    title: 'Tort nuntă 115',
    description: 'Descriere tort nuntă 115',
    image: '/images/wedding-cakes/00115.webp',
    type: 'weddingCakes',
  },
  {
    id: 765,
    title: 'Tort nuntă 116',
    description: 'Descriere tort nuntă 116',
    image: '/images/wedding-cakes/00116.webp',
    type: 'weddingCakes',
  },
  {
    id: 766,
    title: 'Tort nuntă 117',
    description: 'Descriere tort nuntă 117',
    image: '/images/wedding-cakes/00117.webp',
    type: 'weddingCakes',
  },
  {
    id: 767,
    title: 'Tort nuntă 118',
    description: 'Descriere tort nuntă 118',
    image: '/images/wedding-cakes/00118.webp',
    type: 'weddingCakes',
  },
  {
    id: 768,
    title: 'Tort nuntă 119',
    description: 'Descriere tort nuntă 119',
    image: '/images/wedding-cakes/00119.webp',
    type: 'weddingCakes',
  },
  {
    id: 769,
    title: 'Tort nuntă 120',
    description: 'Descriere tort nuntă 120',
    image: '/images/wedding-cakes/00120.webp',
    type: 'weddingCakes',
  },
  {
    id: 770,
    title: 'Tort nuntă 121',
    description: 'Descriere tort nuntă 121',
    image: '/images/wedding-cakes/00121.webp',
    type: 'weddingCakes',
  },
  {
    id: 771,
    title: 'Tort nuntă 122',
    description: 'Descriere tort nuntă 122',
    image: '/images/wedding-cakes/00122.webp',
    type: 'weddingCakes',
  },
  {
    id: 772,
    title: 'Tort nuntă 123',
    description: 'Descriere tort nuntă 123',
    image: '/images/wedding-cakes/00123.webp',
    type: 'weddingCakes',
  },
  {
    id: 773,
    title: 'Tort nuntă 124',
    description: 'Descriere tort nuntă 124',
    image: '/images/wedding-cakes/00124.webp',
    type: 'weddingCakes',
  },
  {
    id: 774,
    title: 'Tort nuntă 125',
    description: 'Descriere tort nuntă 125',
    image: '/images/wedding-cakes/00125.webp',
    type: 'weddingCakes',
  },
  {
    id: 775,
    title: 'Tort nuntă 126',
    description: 'Descriere tort nuntă 126',
    image: '/images/wedding-cakes/00126.webp',
    type: 'weddingCakes',
  },
  {
    id: 776,
    title: 'Tort nuntă 127',
    description: 'Descriere tort nuntă 127',
    image: '/images/wedding-cakes/00127.webp',
    type: 'weddingCakes',
  },
  {
    id: 777,
    title: 'Tort nuntă 128',
    description: 'Descriere tort nuntă 128',
    image: '/images/wedding-cakes/00128.webp',
    type: 'weddingCakes',
  },
  {
    id: 778,
    title: 'Tort nuntă 129',
    description: 'Descriere tort nuntă 129',
    image: '/images/wedding-cakes/00129.webp',
    type: 'weddingCakes',
  },
  {
    id: 779,
    title: 'Tort nuntă 130',
    description: 'Descriere tort nuntă 130',
    image: '/images/wedding-cakes/00130.webp',
    type: 'weddingCakes',
  },
  {
    id: 780,
    title: 'Tort nuntă 131',
    description: 'Descriere tort nuntă 131',
    image: '/images/wedding-cakes/00131.webp',
    type: 'weddingCakes',
  },
  {
    id: 781,
    title: 'Tort nuntă 132',
    description: 'Descriere tort nuntă 132',
    image: '/images/wedding-cakes/00132.webp',
    type: 'weddingCakes',
  },
  {
    id: 782,
    title: 'Tort nuntă 133',
    description: 'Descriere tort nuntă 133',
    image: '/images/wedding-cakes/00133.webp',
    type: 'weddingCakes',
  },
  {
    id: 783,
    title: 'Tort nuntă 134',
    description: 'Descriere tort nuntă 134',
    image: '/images/wedding-cakes/00134.webp',
    type: 'weddingCakes',
  },
  {
    id: 784,
    title: 'Tort nuntă 135',
    description: 'Descriere tort nuntă 135',
    image: '/images/wedding-cakes/00135.webp',
    type: 'weddingCakes',
  },
  {
    id: 785,
    title: 'Tort nuntă 136',
    description: 'Descriere tort nuntă 136',
    image: '/images/wedding-cakes/00136.webp',
    type: 'weddingCakes',
  },
  {
    id: 786,
    title: 'Tort nuntă 137',
    description: 'Descriere tort nuntă 137',
    image: '/images/wedding-cakes/00137.webp',
    type: 'weddingCakes',
  },
  {
    id: 787,
    title: 'Tort nuntă 138',
    description: 'Descriere tort nuntă 138',
    image: '/images/wedding-cakes/00138.webp',
    type: 'weddingCakes',
  },
  {
    id: 788,
    title: 'Tort nuntă 139',
    description: 'Descriere tort nuntă 139',
    image: '/images/wedding-cakes/00139.webp',
    type: 'weddingCakes',
  },
  {
    id: 789,
    title: 'Tort nuntă 140',
    description: 'Descriere tort nuntă 140',
    image: '/images/wedding-cakes/00140.webp',
    type: 'weddingCakes',
  },
  {
    id: 790,
    title: 'Tort nuntă 141',
    description: 'Descriere tort nuntă 141',
    image: '/images/wedding-cakes/00141.webp',
    type: 'weddingCakes',
  },
  {
    id: 791,
    title: 'Tort nuntă 142',
    description: 'Descriere tort nuntă 142',
    image: '/images/wedding-cakes/00142.webp',
    type: 'weddingCakes',
  },
  {
    id: 792,
    title: 'Tort nuntă 143',
    description: 'Descriere tort nuntă 143',
    image: '/images/wedding-cakes/00143.webp',
    type: 'weddingCakes',
  },
  {
    id: 793,
    title: 'Tort nuntă 144',
    description: 'Descriere tort nuntă 144',
    image: '/images/wedding-cakes/00144.webp',
    type: 'weddingCakes',
  },
  {
    id: 794,
    title: 'Tort nuntă 145',
    description: 'Descriere tort nuntă 145',
    image: '/images/wedding-cakes/00145.webp',
    type: 'weddingCakes',
  },
  {
    id: 795,
    title: 'Tort nuntă 146',
    description: 'Descriere tort nuntă 146',
    image: '/images/wedding-cakes/00146.webp',
    type: 'weddingCakes',
  },
  {
    id: 796,
    title: 'Tort nuntă 147',
    description: 'Descriere tort nuntă 147',
    image: '/images/wedding-cakes/00147.webp',
    type: 'weddingCakes',
  },
  {
    id: 797,
    title: 'Tort nuntă 148',
    description: 'Descriere tort nuntă 148',
    image: '/images/wedding-cakes/00148.webp',
    type: 'weddingCakes',
  },
  {
    id: 798,
    title: 'Tort nuntă 149',
    description: 'Descriere tort nuntă 149',
    image: '/images/wedding-cakes/00149.webp',
    type: 'weddingCakes',
  },
  {
    id: 799,
    title: 'Tort nuntă 150',
    description: 'Descriere tort nuntă 150',
    image: '/images/wedding-cakes/00150.webp',
    type: 'weddingCakes',
  },
  {
    id: 800,
    title: 'Tort nuntă 151',
    description: 'Descriere tort nuntă 151',
    image: '/images/wedding-cakes/00151.webp',
    type: 'weddingCakes',
  },
  {
    id: 801,
    title: 'Tort nuntă 152',
    description: 'Descriere tort nuntă 152',
    image: '/images/wedding-cakes/00152.webp',
    type: 'weddingCakes',
  },
  {
    id: 802,
    title: 'Tort nuntă 153',
    description: 'Descriere tort nuntă 153',
    image: '/images/wedding-cakes/00153.webp',
    type: 'weddingCakes',
  },
  {
    id: 803,
    title: 'Tort nuntă 154',
    description: 'Descriere tort nuntă 154',
    image: '/images/wedding-cakes/00154.webp',
    type: 'weddingCakes',
  },
  {
    id: 804,
    title: 'Tort nuntă 155',
    description: 'Descriere tort nuntă 155',
    image: '/images/wedding-cakes/00155.webp',
    type: 'weddingCakes',
  },
  {
    id: 805,
    title: 'Tort nuntă 156',
    description: 'Descriere tort nuntă 156',
    image: '/images/wedding-cakes/00156.webp',
    type: 'weddingCakes',
  },
  {
    id: 806,
    title: 'Tort nuntă 157',
    description: 'Descriere tort nuntă 157',
    image: '/images/wedding-cakes/00157.webp',
    type: 'weddingCakes',
  },
  {
    id: 807,
    title: 'Tort nuntă 158',
    description: 'Descriere tort nuntă 158',
    image: '/images/wedding-cakes/00158.webp',
    type: 'weddingCakes',
  },
  {
    id: 808,
    title: 'Tort nuntă 159',
    description: 'Descriere tort nuntă 159',
    image: '/images/wedding-cakes/00159.webp',
    type: 'weddingCakes',
  },
  {
    id: 809,
    title: 'Tort nuntă 160',
    description: 'Descriere tort nuntă 160',
    image: '/images/wedding-cakes/00160.webp',
    type: 'weddingCakes',
  },
  {
    id: 810,
    title: 'Tort nuntă 161',
    description: 'Descriere tort nuntă 161',
    image: '/images/wedding-cakes/00161.webp',
    type: 'weddingCakes',
  },
  {
    id: 811,
    title: 'Tort nuntă 162',
    description: 'Descriere tort nuntă 162',
    image: '/images/wedding-cakes/00162.webp',
    type: 'weddingCakes',
  },
  {
    id: 812,
    title: 'Tort nuntă 163',
    description: 'Descriere tort nuntă 163',
    image: '/images/wedding-cakes/00163.webp',
    type: 'weddingCakes',
  },
  {
    id: 813,
    title: 'Tort nuntă 164',
    description: 'Descriere tort nuntă 164',
    image: '/images/wedding-cakes/00164.webp',
    type: 'weddingCakes',
  },
  {
    id: 814,
    title: 'Tort nuntă 165',
    description: 'Descriere tort nuntă 165',
    image: '/images/wedding-cakes/00165.webp',
    type: 'weddingCakes',
  },
  {
    id: 815,
    title: 'Tort nuntă 166',
    description: 'Descriere tort nuntă 166',
    image: '/images/wedding-cakes/00166.webp',
    type: 'weddingCakes',
  },
  {
    id: 816,
    title: 'Tort nuntă 167',
    description: 'Descriere tort nuntă 167',
    image: '/images/wedding-cakes/00167.webp',
    type: 'weddingCakes',
  },
  {
    id: 817,
    title: 'Tort nuntă 168',
    description: 'Descriere tort nuntă 168',
    image: '/images/wedding-cakes/00168.webp',
    type: 'weddingCakes',
  },
  {
    id: 818,
    title: 'Tort nuntă 169',
    description: 'Descriere tort nuntă 169',
    image: '/images/wedding-cakes/00169.webp',
    type: 'weddingCakes',
  },
  {
    id: 819,
    title: 'Tort nuntă 170',
    description: 'Descriere tort nuntă 170',
    image: '/images/wedding-cakes/00170.webp',
    type: 'weddingCakes',
  },
  {
    id: 820,
    title: 'Tort nuntă 171',
    description: 'Descriere tort nuntă 171',
    image: '/images/wedding-cakes/00171.webp',
    type: 'weddingCakes',
  },
  {
    id: 821,
    title: 'Tort nuntă 172',
    description: 'Descriere tort nuntă 172',
    image: '/images/wedding-cakes/00172.webp',
    type: 'weddingCakes',
  },
  {
    id: 822,
    title: 'Tort nuntă 173',
    description: 'Descriere tort nuntă 173',
    image: '/images/wedding-cakes/00173.webp',
    type: 'weddingCakes',
  },
  {
    id: 823,
    title: 'Tort nuntă 174',
    description: 'Descriere tort nuntă 174',
    image: '/images/wedding-cakes/00174.webp',
    type: 'weddingCakes',
  },
  {
    id: 824,
    title: 'Tort nuntă 175',
    description: 'Descriere tort nuntă 175',
    image: '/images/wedding-cakes/00175.webp',
    type: 'weddingCakes',
  },
  {
    id: 825,
    title: 'Tort nuntă 176',
    description: 'Descriere tort nuntă 176',
    image: '/images/wedding-cakes/00176.webp',
    type: 'weddingCakes',
  },
  {
    id: 826,
    title: 'Tort nuntă 177',
    description: 'Descriere tort nuntă 177',
    image: '/images/wedding-cakes/00177.webp',
    type: 'weddingCakes',
  },
  {
    id: 827,
    title: 'Tort nuntă 178',
    description: 'Descriere tort nuntă 178',
    image: '/images/wedding-cakes/00178.webp',
    type: 'weddingCakes',
  },
  {
    id: 828,
    title: 'Tort nuntă 179',
    description: 'Descriere tort nuntă 179',
    image: '/images/wedding-cakes/00179.webp',
    type: 'weddingCakes',
  },
  {
    id: 829,
    title: 'Tort nuntă 180',
    description: 'Descriere tort nuntă 180',
    image: '/images/wedding-cakes/00180.webp',
    type: 'weddingCakes',
  },
  {
    id: 830,
    title: 'Tort nuntă 181',
    description: 'Descriere tort nuntă 181',
    image: '/images/wedding-cakes/00181.webp',
    type: 'weddingCakes',
  },
  {
    id: 831,
    title: 'Tort nuntă 182',
    description: 'Descriere tort nuntă 182',
    image: '/images/wedding-cakes/00182.webp',
    type: 'weddingCakes',
  },
  {
    id: 832,
    title: 'Tort nuntă 183',
    description: 'Descriere tort nuntă 183',
    image: '/images/wedding-cakes/00183.webp',
    type: 'weddingCakes',
  },
  {
    id: 833,
    title: 'Tort nuntă 184',
    description: 'Descriere tort nuntă 184',
    image: '/images/wedding-cakes/00184.webp',
    type: 'weddingCakes',
  },
  {
    id: 834,
    title: 'Tort nuntă 185',
    description: 'Descriere tort nuntă 185',
    image: '/images/wedding-cakes/00185.webp',
    type: 'weddingCakes',
  },
  {
    id: 835,
    title: 'Tort nuntă 186',
    description: 'Descriere tort nuntă 186',
    image: '/images/wedding-cakes/00186.webp',
    type: 'weddingCakes',
  },
  {
    id: 836,
    title: 'Tort nuntă 187',
    description: 'Descriere tort nuntă 187',
    image: '/images/wedding-cakes/00187.webp',
    type: 'weddingCakes',
  },
  {
    id: 837,
    title: 'Tort nuntă 188',
    description: 'Descriere tort nuntă 188',
    image: '/images/wedding-cakes/00188.webp',
    type: 'weddingCakes',
  },
  {
    id: 838,
    title: 'Tort nuntă 189',
    description: 'Descriere tort nuntă 189',
    image: '/images/wedding-cakes/00189.webp',
    type: 'weddingCakes',
  },
  {
    id: 839,
    title: 'Tort nuntă 190',
    description: 'Descriere tort nuntă 190',
    image: '/images/wedding-cakes/00190.webp',
    type: 'weddingCakes',
  },
  {
    id: 840,
    title: 'Tort nuntă 191',
    description: 'Descriere tort nuntă 191',
    image: '/images/wedding-cakes/00191.webp',
    type: 'weddingCakes',
  },
  {
    id: 841,
    title: 'Tort nuntă 192',
    description: 'Descriere tort nuntă 192',
    image: '/images/wedding-cakes/00192.webp',
    type: 'weddingCakes',
  },
  {
    id: 842,
    title: 'Tort nuntă 193',
    description: 'Descriere tort nuntă 193',
    image: '/images/wedding-cakes/00193.webp',
    type: 'weddingCakes',
  },
  {
    id: 843,
    title: 'Tort nuntă 194',
    description: 'Descriere tort nuntă 194',
    image: '/images/wedding-cakes/00194.webp',
    type: 'weddingCakes',
  },
  {
    id: 844,
    title: 'Tort nuntă 195',
    description: 'Descriere tort nuntă 195',
    image: '/images/wedding-cakes/00195.webp',
    type: 'weddingCakes',
  },
  {
    id: 845,
    title: 'Tort nuntă 196',
    description: 'Descriere tort nuntă 196',
    image: '/images/wedding-cakes/00196.webp',
    type: 'weddingCakes',
  },
  {
    id: 846,
    title: 'Tort nuntă 197',
    description: 'Descriere tort nuntă 197',
    image: '/images/wedding-cakes/00197.webp',
    type: 'weddingCakes',
  },
  {
    id: 847,
    title: 'Tort nuntă 198',
    description: 'Descriere tort nuntă 198',
    image: '/images/wedding-cakes/00198.webp',
    type: 'weddingCakes',
  },
  {
    id: 848,
    title: 'Tort nuntă 199',
    description: 'Descriere tort nuntă 199',
    image: '/images/wedding-cakes/00199.webp',
    type: 'weddingCakes',
  },
  {
    id: 849,
    title: 'Tort nuntă 200',
    description: 'Descriere tort nuntă 200',
    image: '/images/wedding-cakes/00200.webp',
    type: 'weddingCakes',
  },
  {
    id: 850,
    title: 'Tort nuntă 201',
    description: 'Descriere tort nuntă 201',
    image: '/images/wedding-cakes/00201.webp',
    type: 'weddingCakes',
  },
  {
    id: 851,
    title: 'Tort nuntă 202',
    description: 'Descriere tort nuntă 202',
    image: '/images/wedding-cakes/00202.webp',
    type: 'weddingCakes',
  },
  {
    id: 852,
    title: 'Tort nuntă 203',
    description: 'Descriere tort nuntă 203',
    image: '/images/wedding-cakes/00203.webp',
    type: 'weddingCakes',
  },
  {
    id: 853,
    title: 'Tort nuntă 204',
    description: 'Descriere tort nuntă 204',
    image: '/images/wedding-cakes/00204.webp',
    type: 'weddingCakes',
  },
  {
    id: 854,
    title: 'Tort nuntă 205',
    description: 'Descriere tort nuntă 205',
    image: '/images/wedding-cakes/00205.webp',
    type: 'weddingCakes',
  },
  {
    id: 855,
    title: 'Tort nuntă 206',
    description: 'Descriere tort nuntă 206',
    image: '/images/wedding-cakes/00206.webp',
    type: 'weddingCakes',
  },
  {
    id: 856,
    title: 'Tort nuntă 207',
    description: 'Descriere tort nuntă 207',
    image: '/images/wedding-cakes/00207.webp',
    type: 'weddingCakes',
  },
  {
    id: 857,
    title: 'Tort nuntă 208',
    description: 'Descriere tort nuntă 208',
    image: '/images/wedding-cakes/00208.webp',
    type: 'weddingCakes',
  },
  {
    id: 858,
    title: 'Tort nuntă 209',
    description: 'Descriere tort nuntă 209',
    image: '/images/wedding-cakes/00209.webp',
    type: 'weddingCakes',
  },
  {
    id: 859,
    title: 'Tort nuntă 210',
    description: 'Descriere tort nuntă 210',
    image: '/images/wedding-cakes/00210.webp',
    type: 'weddingCakes',
  },
  {
    id: 860,
    title: 'Tort nuntă 211',
    description: 'Descriere tort nuntă 211',
    image: '/images/wedding-cakes/00211.webp',
    type: 'weddingCakes',
  },
  {
    id: 861,
    title: 'Tort nuntă 212',
    description: 'Descriere tort nuntă 212',
    image: '/images/wedding-cakes/00212.webp',
    type: 'weddingCakes',
  },
  {
    id: 862,
    title: 'Tort nuntă 213',
    description: 'Descriere tort nuntă 213',
    image: '/images/wedding-cakes/00213.webp',
    type: 'weddingCakes',
  },
  {
    id: 863,
    title: 'Tort nuntă 214',
    description: 'Descriere tort nuntă 214',
    image: '/images/wedding-cakes/00214.webp',
    type: 'weddingCakes',
  },
  {
    id: 864,
    title: 'Tort nuntă 215',
    description: 'Descriere tort nuntă 215',
    image: '/images/wedding-cakes/00215.webp',
    type: 'weddingCakes',
  },
  {
    id: 865,
    title: 'Tort nuntă 216',
    description: 'Descriere tort nuntă 216',
    image: '/images/wedding-cakes/00216.webp',
    type: 'weddingCakes',
  },
  {
    id: 866,
    title: 'Tort nuntă 217',
    description: 'Descriere tort nuntă 217',
    image: '/images/wedding-cakes/00217.webp',
    type: 'weddingCakes',
  },
  {
    id: 867,
    title: 'Tort nuntă 218',
    description: 'Descriere tort nuntă 218',
    image: '/images/wedding-cakes/00218.webp',
    type: 'weddingCakes',
  },
  {
    id: 868,
    title: 'Tort nuntă 219',
    description: 'Descriere tort nuntă 219',
    image: '/images/wedding-cakes/00219.webp',
    type: 'weddingCakes',
  },
];

export default productsData;
